/* see /.rollup.config/vendor/web-components-polyfill.js */
var Native = {
  Document_createElement: window.Document.prototype.createElement,
  Document_createElementNS: window.Document.prototype.createElementNS,
  Document_importNode: window.Document.prototype.importNode,
  Document_prepend: window.Document.prototype['prepend'],
  Document_append: window.Document.prototype['append'],
  DocumentFragment_prepend: window.DocumentFragment.prototype['prepend'],
  DocumentFragment_append: window.DocumentFragment.prototype['append'],
  Node_cloneNode: window.Node.prototype.cloneNode,
  Node_appendChild: window.Node.prototype.appendChild,
  Node_insertBefore: window.Node.prototype.insertBefore,
  Node_removeChild: window.Node.prototype.removeChild,
  Node_replaceChild: window.Node.prototype.replaceChild,
  Node_textContent: Object.getOwnPropertyDescriptor(window.Node.prototype, 'textContent'),
  Element_attachShadow: window.Element.prototype['attachShadow'],
  Element_innerHTML: Object.getOwnPropertyDescriptor(window.Element.prototype, 'innerHTML'),
  Element_getAttribute: window.Element.prototype.getAttribute,
  Element_setAttribute: window.Element.prototype.setAttribute,
  Element_removeAttribute: window.Element.prototype.removeAttribute,
  Element_getAttributeNS: window.Element.prototype.getAttributeNS,
  Element_setAttributeNS: window.Element.prototype.setAttributeNS,
  Element_removeAttributeNS: window.Element.prototype.removeAttributeNS,
  Element_insertAdjacentElement: window.Element.prototype['insertAdjacentElement'],
  Element_insertAdjacentHTML: window.Element.prototype['insertAdjacentHTML'],
  Element_prepend: window.Element.prototype['prepend'],
  Element_append: window.Element.prototype['append'],
  Element_before: window.Element.prototype['before'],
  Element_after: window.Element.prototype['after'],
  Element_replaceWith: window.Element.prototype['replaceWith'],
  Element_remove: window.Element.prototype['remove'],
  HTMLElement: window.HTMLElement,
  HTMLElement_innerHTML: Object.getOwnPropertyDescriptor(window.HTMLElement.prototype, 'innerHTML'),
  HTMLElement_insertAdjacentElement: window.HTMLElement.prototype['insertAdjacentElement'],
  HTMLElement_insertAdjacentHTML: window.HTMLElement.prototype['insertAdjacentHTML'],
};

const reservedElementNameSet = new Set();
[
  'annotation-xml',
  'color-profile',
  'font-face',
  'font-face-src',
  'font-face-uri',
  'font-face-format',
  'font-face-name',
  'missing-glyph',
].forEach(item => reservedElementNameSet.add(item));
function isValidCustomElementName(localName) {
  const reserved = reservedElementNameSet.has(localName);
  const validForm = /^[a-z][.0-9_a-z]*-[\-.0-9_a-z]*$/.test(localName);
  return !reserved && validForm;
}
const nativeContains = document.contains ? document.contains.bind(document) :
  document.documentElement.contains.bind(document.documentElement);
function isConnected(node) {
  const nativeValue = node.isConnected;
  if (nativeValue !== undefined) {
    return nativeValue;
  }
  if (nativeContains(node)) {
    return true;
  }
  let current = node;
  while (current && !(current.__CE_isImportDocument || current instanceof Document)) {
    current = current.parentNode || (window.ShadowRoot && current instanceof ShadowRoot ? current.host : undefined);
  }
  return !!(current && (current.__CE_isImportDocument || current instanceof Document));
}
function childrenFromFragment(fragment) {
  const nativeChildren = fragment.children;
  if (nativeChildren) {
    return Array.prototype.slice.call(nativeChildren);
  }
  const children = [];
  for (let n = fragment.firstChild; n; n = n.nextSibling) {
    if (n.nodeType === Node.ELEMENT_NODE) {
      children.push(n);
    }
  }
  return children;
}
function nextSiblingOrAncestorSibling(root, start) {
  let node = start;
  while (node && node !== root && !node.nextSibling) {
    node = node.parentNode;
  }
  return (!node || node === root) ? null : node.nextSibling;
}
function nextNode(root, start) {
  return start.firstChild ? start.firstChild : nextSiblingOrAncestorSibling(root, start);
}
function walkDeepDescendantElements(root, callback, visitedImports) {
  let node = root;
  while (node) {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const element = (node);
      callback(element);
      const localName = element.localName;
      if (localName === 'link' && element.getAttribute('rel') === 'import') {
        const importNode =  (element).import;
        if (visitedImports === undefined) {
          visitedImports = new Set();
        }
        if (importNode instanceof Node && !visitedImports.has(importNode)) {
          visitedImports.add(importNode);
          for (let child = importNode.firstChild; child; child = child.nextSibling) {
            walkDeepDescendantElements(child, callback, visitedImports);
          }
        }
        node = nextSiblingOrAncestorSibling(root, element);
        continue;
      } else if (localName === 'template') {
        node = nextSiblingOrAncestorSibling(root, element);
        continue;
      }
      const shadowRoot = element.__CE_shadowRoot;
      if (shadowRoot) {
        for (let child = shadowRoot.firstChild; child; child = child.nextSibling) {
          walkDeepDescendantElements(child, callback, visitedImports);
        }
      }
    }
    node = nextNode(root, node);
  }
}
function setPropertyUnchecked(destination, name, value) {
  destination[name] = value;
}

class DocumentConstructionObserver {
  constructor(internals, doc) {
    this._internals = internals;
    this._document = doc;
    this._observer = undefined;
    this._internals.patchAndUpgradeTree(this._document);
    if (this._document.readyState === 'loading') {
      this._observer = new MutationObserver(this._handleMutations.bind(this));
      this._observer.observe(this._document, {
        childList: true,
        subtree: true,
      });
    }
  }
  disconnect() {
    if (this._observer) {
      this._observer.disconnect();
    }
  }
  _handleMutations(mutations) {
    const readyState = this._document.readyState;
    if (readyState === 'interactive' || readyState === 'complete') {
      this.disconnect();
    }
    for (let i = 0; i < mutations.length; i++) {
      const addedNodes = mutations[i].addedNodes;
      for (let j = 0; j < addedNodes.length; j++) {
        const node = addedNodes[j];
        this._internals.patchAndUpgradeTree(node);
      }
    }
  }
}

class Deferred {
  constructor() {
    this._value = undefined;
    this._resolve = undefined;
    this._promise = new Promise(resolve => {
      this._resolve = resolve;
      if (this._value) {
        resolve(this._value);
      }
    });
  }
  resolve(value) {
    if (this._value) {
      throw new Error('Already resolved.');
    }
    this._value = value;
    if (this._resolve) {
      this._resolve(value);
    }
  }
  toPromise() {
    return this._promise;
  }
}

class CustomElementRegistry {
  constructor(internals) {
    this._localNameToConstructorGetter = new Map();
    this._localNameToDefinition = new Map();
    this._constructorToDefinition = new Map();
    this._elementDefinitionIsRunning = false;
    this._internals = internals;
    this._whenDefinedDeferred = new Map();
    this._flushCallback = fn => fn();
    this._flushPending = false;
    this._unflushedLocalNames = [];
    this._documentConstructionObserver = internals.useDocumentConstructionObserver ?
      new DocumentConstructionObserver(internals, document) : undefined;
  }
  polyfillDefineLazy(localName, constructorGetter) {
    if (!(constructorGetter instanceof Function)) {
      throw new TypeError('Custom element constructor getters must be functions.');
    }
    this.internal_assertCanDefineLocalName(localName);
    this._localNameToConstructorGetter.set(localName, constructorGetter);
    this._unflushedLocalNames.push(localName);
    if (!this._flushPending) {
      this._flushPending = true;
      this._flushCallback(() => this._flush());
    }
  }
  define(localName, constructor) {
    if (!(constructor instanceof Function)) {
      throw new TypeError('Custom element constructors must be functions.');
    }
    this.internal_assertCanDefineLocalName(localName);
    this.internal_reifyDefinition(localName, constructor);
    this._unflushedLocalNames.push(localName);
    if (!this._flushPending) {
      this._flushPending = true;
      this._flushCallback(() => this._flush());
    }
  }
  internal_assertCanDefineLocalName(localName) {
    if (!isValidCustomElementName(localName)) {
      throw new SyntaxError(`The element name '${localName}' is not valid.`);
    }
    if (this.internal_localNameToDefinition(localName)) {
      throw new Error(`A custom element with name '${localName}' has already been defined.`);
    }
    if (this._elementDefinitionIsRunning) {
      throw new Error('A custom element is already being defined.');
    }
  }
  internal_reifyDefinition(localName, constructor) {
    this._elementDefinitionIsRunning = true;
    let connectedCallback;
    let disconnectedCallback;
    let adoptedCallback;
    let attributeChangedCallback;
    let observedAttributes;
    try {
      const prototype = constructor.prototype;
      if (!(prototype instanceof Object)) {
        throw new TypeError('The custom element constructor\'s prototype is not an object.');
      }
      function getCallback(name) {
        const callbackValue = prototype[name];
        if (callbackValue !== undefined && !(callbackValue instanceof Function)) {
          throw new Error(`The '${name}' callback must be a function.`);
        }
        return callbackValue;
      }
      connectedCallback = getCallback('connectedCallback');
      disconnectedCallback = getCallback('disconnectedCallback');
      adoptedCallback = getCallback('adoptedCallback');
      attributeChangedCallback = getCallback('attributeChangedCallback');
      observedAttributes = (attributeChangedCallback &&
        constructor['observedAttributes']) || [];
    } catch (e) {
      throw e;
    } finally {
      this._elementDefinitionIsRunning = false;
    }
    const definition = {
      localName,
      constructorFunction: constructor,
      connectedCallback,
      disconnectedCallback,
      adoptedCallback,
      attributeChangedCallback,
      observedAttributes,
      constructionStack: [],
    };
    this._localNameToDefinition.set(localName, definition);
    this._constructorToDefinition.set(definition.constructorFunction, definition);
    return definition;
  }
  upgrade(node) {
    this._internals.patchAndUpgradeTree(node);
  }
  _flush() {
    if (this._flushPending === false) return;
    this._flushPending = false;
    const elementsWithStableDefinitions = [];
    const unflushedLocalNames = this._unflushedLocalNames;
    const elementsWithPendingDefinitions = new Map();
    for (let i = 0; i < unflushedLocalNames.length; i++) {
      elementsWithPendingDefinitions.set(unflushedLocalNames[i], []);
    }
    this._internals.patchAndUpgradeTree(document, {
      upgrade: element => {
        if (element.__CE_state !== undefined) return;
        const localName = element.localName;
        const pendingElements = elementsWithPendingDefinitions.get(localName);
        if (pendingElements) {
          pendingElements.push(element);
        } else if (this._localNameToDefinition.has(localName)) {
          elementsWithStableDefinitions.push(element);
        }
      },
    });
    for (let i = 0; i < elementsWithStableDefinitions.length; i++) {
      this._internals.upgradeReaction(elementsWithStableDefinitions[i]);
    }
    for (let i = 0; i < unflushedLocalNames.length; i++) {
      const localName = unflushedLocalNames[i];
      const pendingUpgradableElements = elementsWithPendingDefinitions.get(localName);
      for (let i = 0; i < pendingUpgradableElements.length; i++) {
        this._internals.upgradeReaction(pendingUpgradableElements[i]);
      }
      const deferred = this._whenDefinedDeferred.get(localName);
      if (deferred) {
        deferred.resolve(undefined);
      }
    }
    unflushedLocalNames.length = 0;
  }
  get(localName) {
    const definition = this.internal_localNameToDefinition(localName);
    if (definition) {
      return definition.constructorFunction;
    }
    return undefined;
  }
  whenDefined(localName) {
    if (!isValidCustomElementName(localName)) {
      return Promise.reject(new SyntaxError(`'${localName}' is not a valid custom element name.`));
    }
    const prior = this._whenDefinedDeferred.get(localName);
    if (prior) {
      return prior.toPromise();
    }
    const deferred = new Deferred();
    this._whenDefinedDeferred.set(localName, deferred);
    const anyDefinitionExists = this._localNameToDefinition.has(localName) ||
        this._localNameToConstructorGetter.has(localName);
    const definitionHasFlushed = this._unflushedLocalNames.indexOf(localName) === -1;
    if (anyDefinitionExists && definitionHasFlushed) {
      deferred.resolve(undefined);
    }
    return deferred.toPromise();
  }
  polyfillWrapFlushCallback(outer) {
    if (this._documentConstructionObserver) {
      this._documentConstructionObserver.disconnect();
    }
    const inner = this._flushCallback;
    this._flushCallback = flush => outer(() => inner(flush));
  }
  internal_localNameToDefinition(localName) {
    const existingDefinition = this._localNameToDefinition.get(localName);
    if (existingDefinition) {
      return existingDefinition;
    }
    const constructorGetter = this._localNameToConstructorGetter.get(localName);
    if (constructorGetter) {
      this._localNameToConstructorGetter.delete(localName);
      try {
        return this.internal_reifyDefinition(localName, constructorGetter());
      } catch (e) {
        this._internals.reportTheException(e);
      }
    }
    return undefined;
  }
  internal_constructorToDefinition(constructor) {
    return this._constructorToDefinition.get(constructor);
  }
}
window['CustomElementRegistry'] = CustomElementRegistry;
CustomElementRegistry.prototype['define'] = CustomElementRegistry.prototype.define;
CustomElementRegistry.prototype['upgrade'] = CustomElementRegistry.prototype.upgrade;
CustomElementRegistry.prototype['get'] = CustomElementRegistry.prototype.get;
CustomElementRegistry.prototype['whenDefined'] = CustomElementRegistry.prototype.whenDefined;
CustomElementRegistry.prototype['polyfillDefineLazy'] = CustomElementRegistry.prototype.polyfillDefineLazy;
CustomElementRegistry.prototype['polyfillWrapFlushCallback'] = CustomElementRegistry.prototype.polyfillWrapFlushCallback;

const CustomElementState = {
  custom: 1,
  failed: 2,
};

const NS_HTML = 'http://www.w3.org/1999/xhtml';
class CustomElementInternals {
  constructor(options) {
    this._patchesNode = [];
    this._patchesElement = [];
    this._hasPatches = false;
    this.shadyDomFastWalk = options.shadyDomFastWalk;
    this.useDocumentConstructionObserver = !options.noDocumentConstructionObserver;
  }
  forEachElement(node, callback, visitedImports) {
    const sd = window['ShadyDOM'];
    if (this.shadyDomFastWalk && sd && sd['inUse']) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const element = (node);
        callback(element);
      }
      if (node.querySelectorAll) {
        const elements = sd['nativeMethods'].querySelectorAll.call(node, '*');
        for (let i = 0; i < elements.length; i++) {
          callback(elements[i]);
        }
      }
    } else {
      walkDeepDescendantElements(node, callback, visitedImports);
    }
  }
  addNodePatch(patch) {
    this._hasPatches = true;
    this._patchesNode.push(patch);
  }
  addElementPatch(patch) {
    this._hasPatches = true;
    this._patchesElement.push(patch);
  }
  patchTree(node) {
    if (!this._hasPatches) return;
    this.forEachElement(node, element => this.patchElement(element));
  }
  patchNode(node) {
    if (!this._hasPatches) return;
    if (node.__CE_patched) return;
    node.__CE_patched = true;
    for (let i = 0; i < this._patchesNode.length; i++) {
      this._patchesNode[i](node);
    }
  }
  patchElement(element) {
    if (!this._hasPatches) return;
    if (element.__CE_patched) return;
    element.__CE_patched = true;
    for (let i = 0; i < this._patchesNode.length; i++) {
      this._patchesNode[i](element);
    }
    for (let i = 0; i < this._patchesElement.length; i++) {
      this._patchesElement[i](element);
    }
  }
  connectTree(root) {
    const elements = [];
    this.forEachElement(root, element => elements.push(element));
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      if (element.__CE_state === CustomElementState.custom) {
        this.connectedCallback(element);
      } else {
        this.upgradeReaction(element);
      }
    }
  }
  disconnectTree(root) {
    const elements = [];
    this.forEachElement(root, element => elements.push(element));
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];
      if (element.__CE_state === CustomElementState.custom) {
        this.disconnectedCallback(element);
      }
    }
  }
  patchAndUpgradeTree(root, options = {}) {
    const visitedImports = options.visitedImports;
    const upgrade = options.upgrade || (element => this.upgradeReaction(element));
    const elements = [];
    const gatherElements = element => {
      if (this._hasPatches) {
        this.patchElement(element);
      }
      if (element.localName === 'link' &&
          element.getAttribute('rel') === 'import') {
        const importNode =  (element.import);
        if (importNode instanceof Node) {
          importNode.__CE_isImportDocument = true;
          importNode.__CE_registry = document.__CE_registry;
        }
        if (importNode && importNode.readyState === 'complete') {
          importNode.__CE_documentLoadHandled = true;
        } else {
          element.addEventListener('load', () => {
            const importNode =  (element.import);
            if (importNode.__CE_documentLoadHandled) return;
            importNode.__CE_documentLoadHandled = true;
            const clonedVisitedImports = new Set();
            if (visitedImports) {
              visitedImports.forEach(item => clonedVisitedImports.add(item));
              clonedVisitedImports.delete(importNode);
            }
            this.patchAndUpgradeTree(importNode, {visitedImports: clonedVisitedImports, upgrade});
          });
        }
      } else {
        elements.push(element);
      }
    };
    this.forEachElement(root, gatherElements, visitedImports);
    for (let i = 0; i < elements.length; i++) {
      upgrade(elements[i]);
    }
  }
  upgradeReaction(element) {
    try {
      const definition = this._lookupACustomElementDefinition(
           (element.ownerDocument), element.localName);
      if (definition) {
        this._upgradeAnElement(element, definition);
      }
    } catch (e) {
      this.reportTheException(e);
    }
  }
  _upgradeAnElement(element, definition) {
    const currentState = element.__CE_state;
    if (currentState !== undefined) return;
    definition.constructionStack.push(element);
    try {
      try {
        let result = new (definition.constructorFunction)();
        if (result !== element) {
          throw new Error('The custom element constructor did not produce the element being upgraded.');
        }
      } finally {
        definition.constructionStack.pop();
      }
    } catch (e) {
      element.__CE_state = CustomElementState.failed;
      throw e;
    }
    element.__CE_state = CustomElementState.custom;
    element.__CE_definition = definition;
    if (definition.attributeChangedCallback && element.hasAttributes()) {
      const observedAttributes = definition.observedAttributes;
      for (let i = 0; i < observedAttributes.length; i++) {
        const name = observedAttributes[i];
        const value = element.getAttribute(name);
        if (value !== null) {
          this.attributeChangedCallback(element, name, null, value, null);
        }
      }
    }
    if (isConnected(element)) {
      this.connectedCallback(element);
    }
  }
  connectedCallback(element) {
    const definition = element.__CE_definition;
    if (definition.connectedCallback) {
      try {
        definition.connectedCallback.call(element);
      } catch (e) {
        this.reportTheException(e);
      }
    }
  }
  disconnectedCallback(element) {
    const definition = element.__CE_definition;
    if (definition.disconnectedCallback) {
      try {
        definition.disconnectedCallback.call(element);
      } catch (e) {
        this.reportTheException(e);
      }
    }
  }
  attributeChangedCallback(element, name, oldValue, newValue, namespace) {
    const definition = element.__CE_definition;
    if (
      definition.attributeChangedCallback &&
      definition.observedAttributes.indexOf(name) > -1
    ) {
      try {
        definition.attributeChangedCallback.call(element, name, oldValue, newValue, namespace);
      } catch (e) {
        this.reportTheException(e);
      }
    }
  }
  _lookupACustomElementDefinition(doc, localName) {
    const registry =
         (doc.__CE_registry);
    if (!registry) return;
    if (!doc.defaultView && !doc.__CE_isImportDocument) return;
    return registry.internal_localNameToDefinition(localName);
  }
  createAnElement(doc, localName, namespace) {
    const registry =
         (doc.__CE_registry);
    if (registry && (namespace === null || namespace === NS_HTML)) {
      const definition = registry.internal_localNameToDefinition(localName);
      if (definition) {
        try {
          const result = new (definition.constructorFunction)();
          if (result.__CE_state === undefined ||
              result.__CE_definition === undefined) {
            throw new Error('Failed to construct \'' + localName + '\': ' +
                'The returned value was not constructed with the HTMLElement ' +
                'constructor.');
          }
          if (result.namespaceURI !== NS_HTML) {
            throw new Error('Failed to construct \'' + localName + '\': ' +
                'The constructed element\'s namespace must be the HTML ' +
                'namespace.');
          }
          if (result.hasAttributes()) {
            throw new Error('Failed to construct \'' + localName + '\': ' +
                'The constructed element must not have any attributes.');
          }
          if (result.firstChild !== null) {
            throw new Error('Failed to construct \'' + localName + '\': ' +
                'The constructed element must not have any children.');
          }
          if (result.parentNode !== null) {
            throw new Error('Failed to construct \'' + localName + '\': ' +
                'The constructed element must not have a parent node.');
          }
          if (result.ownerDocument !== doc) {
            throw new Error('Failed to construct \'' + localName + '\': ' +
                'The constructed element\'s owner document is incorrect.');
          }
          if (result.localName !== localName) {
            throw new Error('Failed to construct \'' + localName + '\': ' +
                'The constructed element\'s local name is incorrect.');
          }
          return result;
        } catch (e) {
          this.reportTheException(e);
          const result =  (namespace === null ?
              Native.Document_createElement.call(doc, localName) :
              Native.Document_createElementNS.call(doc, namespace, localName));
          Object.setPrototypeOf(result, HTMLUnknownElement.prototype);
          result.__CE_state = CustomElementState.failed;
          result.__CE_definition = undefined;
          this.patchElement(result);
          return result;
        }
      }
    }
    const result =  (namespace === null ?
        Native.Document_createElement.call(doc, localName) :
        Native.Document_createElementNS.call(doc, namespace, localName));
    this.patchElement(result);
    return result;
  }
  reportTheException(error) {
    const message = error.message;
    const filename =
         error.sourceURL ||  error.fileName || "";
    const lineno =
         error.line ||  error.lineNumber || 0;
    const colno =
         error.column ||  error.columnNumber || 0;
    let event = undefined;
    if (ErrorEvent.prototype.initErrorEvent === undefined) {
      event = new ErrorEvent('error',
          {cancelable: true, message, filename, lineno, colno, error});
    } else {
      event =  (document.createEvent('ErrorEvent'));
      event.initErrorEvent('error', false, true, message, filename, lineno);
      event.preventDefault = function() {
        Object.defineProperty(this, 'defaultPrevented', {
          configurable: true,
          get: function() { return true; },
        });
      };
    }
    if (event.error === undefined) {
      Object.defineProperty(event, 'error', {
        configurable: true,
        enumerable: true,
        get: function() { return error; },
      });
    }
    window.dispatchEvent(event);
    if (!event.defaultPrevented) {
      console.error(error);
    }
  }
}

class AlreadyConstructedMarker {}
var AlreadyConstructedMarker$1 = new AlreadyConstructedMarker();

function PatchHTMLElement(internals) {
  window['HTMLElement'] = (function() {
    const PatchedHTMLElement = function HTMLElement() {
      const constructor =  (this.constructor);
      const registry =
          (document.__CE_registry);
      const definition = registry.internal_constructorToDefinition(constructor);
      if (!definition) {
        throw new Error('Failed to construct a custom element: ' +
            'The constructor was not registered with `customElements`.');
      }
      const constructionStack = definition.constructionStack;
      if (constructionStack.length === 0) {
        const element =  (Native.Document_createElement.call(document, definition.localName));
        Object.setPrototypeOf(element, constructor.prototype);
        element.__CE_state = CustomElementState.custom;
        element.__CE_definition = definition;
        internals.patchElement(element);
        return element;
      }
      const lastIndex = constructionStack.length - 1;
      const element = constructionStack[lastIndex];
      if (element === AlreadyConstructedMarker$1) {
        const localName = definition.localName;
        throw new Error('Failed to construct \'' + localName + '\': ' +
            'This element was already constructed.');
      }
      const toConstructElement =  (element);
      constructionStack[lastIndex] = AlreadyConstructedMarker$1;
      Object.setPrototypeOf(toConstructElement, constructor.prototype);
      internals.patchElement(toConstructElement);
      return toConstructElement;
    };
    PatchedHTMLElement.prototype = Native.HTMLElement.prototype;
    Object.defineProperty(PatchedHTMLElement.prototype, 'constructor', {
      writable: true,
      configurable: true,
      enumerable: false,
      value: PatchedHTMLElement
    });
    return PatchedHTMLElement;
  })();
}

function PatchParentNode(internals, destination, builtIn) {
  function appendPrependPatch(builtInMethod) {
    return  function(...nodes) {
      const flattenedNodes = [];
      const connectedElements = [];
      for (var i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if (node instanceof Element && isConnected(node)) {
          connectedElements.push(node);
        }
        if (node instanceof DocumentFragment) {
          for (let child = node.firstChild; child; child = child.nextSibling) {
            flattenedNodes.push(child);
          }
        } else {
          flattenedNodes.push(node);
        }
      }
      builtInMethod.apply(this, nodes);
      for (let i = 0; i < connectedElements.length; i++) {
        internals.disconnectTree(connectedElements[i]);
      }
      if (isConnected(this)) {
        for (let i = 0; i < flattenedNodes.length; i++) {
          const node = flattenedNodes[i];
          if (node instanceof Element) {
            internals.connectTree(node);
          }
        }
      }
    };
  }
  if (builtIn.prepend !== undefined) {
    setPropertyUnchecked(destination, 'prepend', appendPrependPatch(builtIn.prepend));
  }
  if (builtIn.append !== undefined) {
    setPropertyUnchecked(destination, 'append', appendPrependPatch(builtIn.append));
  }
}

function PatchDocument(internals) {
  setPropertyUnchecked(Document.prototype, 'createElement',
    function(localName) {
      return internals.createAnElement(this, localName, null);
    });
  setPropertyUnchecked(Document.prototype, 'importNode',
    function(node, deep) {
      const clone =  (Native.Document_importNode.call(this, node, !!deep));
      if (!this.__CE_registry) {
        internals.patchTree(clone);
      } else {
        internals.patchAndUpgradeTree(clone);
      }
      return clone;
    });
  setPropertyUnchecked(Document.prototype, 'createElementNS',
    function(namespace, localName) {
      return internals.createAnElement(this, localName, namespace);
    });
  PatchParentNode(internals, Document.prototype, {
    prepend: Native.Document_prepend,
    append: Native.Document_append,
  });
}

function PatchDocumentFragment(internals) {
  PatchParentNode(internals, DocumentFragment.prototype, {
    prepend: Native.DocumentFragment_prepend,
    append: Native.DocumentFragment_append,
  });
}

function PatchNode(internals) {
  setPropertyUnchecked(Node.prototype, 'insertBefore',
    function(node, refNode) {
      if (node instanceof DocumentFragment) {
        const insertedNodes = childrenFromFragment(node);
        const nativeResult = Native.Node_insertBefore.call(this, node, refNode);
        if (isConnected(this)) {
          for (let i = 0; i < insertedNodes.length; i++) {
            internals.connectTree(insertedNodes[i]);
          }
        }
        return nativeResult;
      }
      const nodeWasConnectedElement = node instanceof Element && isConnected(node);
      const nativeResult = Native.Node_insertBefore.call(this, node, refNode);
      if (nodeWasConnectedElement) {
        internals.disconnectTree(node);
      }
      if (isConnected(this)) {
        internals.connectTree(node);
      }
      return nativeResult;
    });
  setPropertyUnchecked(Node.prototype, 'appendChild',
    function(node) {
      if (node instanceof DocumentFragment) {
        const insertedNodes = childrenFromFragment(node);
        const nativeResult = Native.Node_appendChild.call(this, node);
        if (isConnected(this)) {
          for (let i = 0; i < insertedNodes.length; i++) {
            internals.connectTree(insertedNodes[i]);
          }
        }
        return nativeResult;
      }
      const nodeWasConnectedElement = node instanceof Element && isConnected(node);
      const nativeResult = Native.Node_appendChild.call(this, node);
      if (nodeWasConnectedElement) {
        internals.disconnectTree(node);
      }
      if (isConnected(this)) {
        internals.connectTree(node);
      }
      return nativeResult;
    });
  setPropertyUnchecked(Node.prototype, 'cloneNode',
    function(deep) {
      const clone = Native.Node_cloneNode.call(this, !!deep);
      if (!this.ownerDocument.__CE_registry) {
        internals.patchTree(clone);
      } else {
        internals.patchAndUpgradeTree(clone);
      }
      return clone;
    });
  setPropertyUnchecked(Node.prototype, 'removeChild',
    function(node) {
      const nodeWasConnectedElement = node instanceof Element && isConnected(node);
      const nativeResult = Native.Node_removeChild.call(this, node);
      if (nodeWasConnectedElement) {
        internals.disconnectTree(node);
      }
      return nativeResult;
    });
  setPropertyUnchecked(Node.prototype, 'replaceChild',
    function(nodeToInsert, nodeToRemove) {
      if (nodeToInsert instanceof DocumentFragment) {
        const insertedNodes = childrenFromFragment(nodeToInsert);
        const nativeResult = Native.Node_replaceChild.call(this, nodeToInsert, nodeToRemove);
        if (isConnected(this)) {
          internals.disconnectTree(nodeToRemove);
          for (let i = 0; i < insertedNodes.length; i++) {
            internals.connectTree(insertedNodes[i]);
          }
        }
        return nativeResult;
      }
      const nodeToInsertWasConnectedElement = nodeToInsert instanceof Element &&
        isConnected(nodeToInsert);
      const nativeResult = Native.Node_replaceChild.call(this, nodeToInsert, nodeToRemove);
      const thisIsConnected = isConnected(this);
      if (thisIsConnected) {
        internals.disconnectTree(nodeToRemove);
      }
      if (nodeToInsertWasConnectedElement) {
        internals.disconnectTree(nodeToInsert);
      }
      if (thisIsConnected) {
        internals.connectTree(nodeToInsert);
      }
      return nativeResult;
    });
  function patch_textContent(destination, baseDescriptor) {
    Object.defineProperty(destination, 'textContent', {
      enumerable: baseDescriptor.enumerable,
      configurable: true,
      get: baseDescriptor.get,
      set:  function(assignedValue) {
        if (this.nodeType === Node.TEXT_NODE) {
          baseDescriptor.set.call(this, assignedValue);
          return;
        }
        let removedNodes = undefined;
        if (this.firstChild) {
          const childNodes = this.childNodes;
          const childNodesLength = childNodes.length;
          if (childNodesLength > 0 && isConnected(this)) {
            removedNodes = new Array(childNodesLength);
            for (let i = 0; i < childNodesLength; i++) {
              removedNodes[i] = childNodes[i];
            }
          }
        }
        baseDescriptor.set.call(this, assignedValue);
        if (removedNodes) {
          for (let i = 0; i < removedNodes.length; i++) {
            internals.disconnectTree(removedNodes[i]);
          }
        }
      },
    });
  }
  if (Native.Node_textContent && Native.Node_textContent.get) {
    patch_textContent(Node.prototype, Native.Node_textContent);
  } else {
    internals.addNodePatch(function(element) {
      patch_textContent(element, {
        enumerable: true,
        configurable: true,
        get:  function() {
          const parts = [];
          for (let n = this.firstChild; n; n = n.nextSibling) {
            if (n.nodeType === Node.COMMENT_NODE) {
              continue;
            }
            parts.push(n.textContent);
          }
          return parts.join('');
        },
        set:  function(assignedValue) {
          while (this.firstChild) {
            Native.Node_removeChild.call(this, this.firstChild);
          }
          if (assignedValue != null && assignedValue !== '') {
            Native.Node_appendChild.call(this, document.createTextNode(assignedValue));
          }
        },
      });
    });
  }
}

function PatchChildNode(internals, destination, builtIn) {
  function beforeAfterPatch(builtInMethod) {
    return  function(...nodes) {
      const flattenedNodes = [];
      const connectedElements = [];
      for (var i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        if (node instanceof Element && isConnected(node)) {
          connectedElements.push(node);
        }
        if (node instanceof DocumentFragment) {
          for (let child = node.firstChild; child; child = child.nextSibling) {
            flattenedNodes.push(child);
          }
        } else {
          flattenedNodes.push(node);
        }
      }
      builtInMethod.apply(this, nodes);
      for (let i = 0; i < connectedElements.length; i++) {
        internals.disconnectTree(connectedElements[i]);
      }
      if (isConnected(this)) {
        for (let i = 0; i < flattenedNodes.length; i++) {
          const node = flattenedNodes[i];
          if (node instanceof Element) {
            internals.connectTree(node);
          }
        }
      }
    };
  }
  if (builtIn.before !== undefined) {
    setPropertyUnchecked(destination, 'before', beforeAfterPatch(builtIn.before));
  }
  if (builtIn.after !== undefined) {
    setPropertyUnchecked(destination, 'after', beforeAfterPatch(builtIn.after));
  }
  if (builtIn.replaceWith !== undefined) {
    setPropertyUnchecked(destination, 'replaceWith',
      function(...nodes) {
        const flattenedNodes = [];
        const connectedElements = [];
        for (var i = 0; i < nodes.length; i++) {
          const node = nodes[i];
          if (node instanceof Element && isConnected(node)) {
            connectedElements.push(node);
          }
          if (node instanceof DocumentFragment) {
            for (let child = node.firstChild; child; child = child.nextSibling) {
              flattenedNodes.push(child);
            }
          } else {
            flattenedNodes.push(node);
          }
        }
        const wasConnected = isConnected(this);
        builtIn.replaceWith.apply(this, nodes);
        for (let i = 0; i < connectedElements.length; i++) {
          internals.disconnectTree(connectedElements[i]);
        }
        if (wasConnected) {
          internals.disconnectTree(this);
          for (let i = 0; i < flattenedNodes.length; i++) {
            const node = flattenedNodes[i];
            if (node instanceof Element) {
              internals.connectTree(node);
            }
          }
        }
      });
    }
  if (builtIn.remove !== undefined) {
    setPropertyUnchecked(destination, 'remove',
      function() {
        const wasConnected = isConnected(this);
        builtIn.remove.call(this);
        if (wasConnected) {
          internals.disconnectTree(this);
        }
      });
  }
}

function PatchElement(internals) {
  if (Native.Element_attachShadow) {
    setPropertyUnchecked(Element.prototype, 'attachShadow',
      function(init) {
        const shadowRoot = Native.Element_attachShadow.call(this, init);
        internals.patchNode(shadowRoot);
        this.__CE_shadowRoot = shadowRoot;
        return shadowRoot;
      });
  }
  function patch_innerHTML(destination, baseDescriptor) {
    Object.defineProperty(destination, 'innerHTML', {
      enumerable: baseDescriptor.enumerable,
      configurable: true,
      get: baseDescriptor.get,
      set:  function(htmlString) {
        const isConnected$1 = isConnected(this);
        let removedElements = undefined;
        if (isConnected$1) {
          removedElements = [];
          internals.forEachElement(this, element => {
            if (element !== this) {
              removedElements.push(element);
            }
          });
        }
        baseDescriptor.set.call(this, htmlString);
        if (removedElements) {
          for (let i = 0; i < removedElements.length; i++) {
            const element = removedElements[i];
            if (element.__CE_state === CustomElementState.custom) {
              internals.disconnectedCallback(element);
            }
          }
        }
        if (!this.ownerDocument.__CE_registry) {
          internals.patchTree(this);
        } else {
          internals.patchAndUpgradeTree(this);
        }
        return htmlString;
      },
    });
  }
  if (Native.Element_innerHTML && Native.Element_innerHTML.get) {
    patch_innerHTML(Element.prototype, Native.Element_innerHTML);
  } else if (Native.HTMLElement_innerHTML && Native.HTMLElement_innerHTML.get) {
    patch_innerHTML(HTMLElement.prototype, Native.HTMLElement_innerHTML);
  } else {
    internals.addElementPatch(function(element) {
      patch_innerHTML(element, {
        enumerable: true,
        configurable: true,
        get:  function() {
          return  (
                     Native.Node_cloneNode.call(this, true))
              .innerHTML;
        },
        set:  function(assignedValue) {
          const isTemplate = (this.localName === 'template');
          const content = isTemplate ? (
            (this)).content : this;
          const rawElement = Native.Document_createElementNS.call(document,
              this.namespaceURI, this.localName);
          rawElement.innerHTML = assignedValue;
          while (content.childNodes.length > 0) {
            Native.Node_removeChild.call(content, content.childNodes[0]);
          }
          const container = isTemplate ?
               (rawElement).content :
              rawElement;
          while (container.childNodes.length > 0) {
            Native.Node_appendChild.call(content, container.childNodes[0]);
          }
        },
      });
    });
  }
  setPropertyUnchecked(Element.prototype, 'setAttribute',
    function(name, newValue) {
      if (this.__CE_state !== CustomElementState.custom) {
        return Native.Element_setAttribute.call(this, name, newValue);
      }
      const oldValue = Native.Element_getAttribute.call(this, name);
      Native.Element_setAttribute.call(this, name, newValue);
      newValue = Native.Element_getAttribute.call(this, name);
      internals.attributeChangedCallback(this, name, oldValue, newValue, null);
    });
  setPropertyUnchecked(Element.prototype, 'setAttributeNS',
    function(namespace, name, newValue) {
      if (this.__CE_state !== CustomElementState.custom) {
        return Native.Element_setAttributeNS.call(this, namespace, name, newValue);
      }
      const oldValue = Native.Element_getAttributeNS.call(this, namespace, name);
      Native.Element_setAttributeNS.call(this, namespace, name, newValue);
      newValue = Native.Element_getAttributeNS.call(this, namespace, name);
      internals.attributeChangedCallback(this, name, oldValue, newValue, namespace);
    });
  setPropertyUnchecked(Element.prototype, 'removeAttribute',
    function(name) {
      if (this.__CE_state !== CustomElementState.custom) {
        return Native.Element_removeAttribute.call(this, name);
      }
      const oldValue = Native.Element_getAttribute.call(this, name);
      Native.Element_removeAttribute.call(this, name);
      if (oldValue !== null) {
        internals.attributeChangedCallback(this, name, oldValue, null, null);
      }
    });
  setPropertyUnchecked(Element.prototype, 'removeAttributeNS',
    function(namespace, name) {
      if (this.__CE_state !== CustomElementState.custom) {
        return Native.Element_removeAttributeNS.call(this, namespace, name);
      }
      const oldValue = Native.Element_getAttributeNS.call(this, namespace, name);
      Native.Element_removeAttributeNS.call(this, namespace, name);
      const newValue = Native.Element_getAttributeNS.call(this, namespace, name);
      if (oldValue !== newValue) {
        internals.attributeChangedCallback(this, name, oldValue, newValue, namespace);
      }
    });
  function patch_insertAdjacentElement(destination, baseMethod) {
    setPropertyUnchecked(destination, 'insertAdjacentElement',
      function(position, element) {
        const wasConnected = isConnected(element);
        const insertedElement =
          (baseMethod.call(this, position, element));
        if (wasConnected) {
          internals.disconnectTree(element);
        }
        if (isConnected(insertedElement)) {
          internals.connectTree(element);
        }
        return insertedElement;
      });
  }
  if (Native.HTMLElement_insertAdjacentElement) {
    patch_insertAdjacentElement(HTMLElement.prototype, Native.HTMLElement_insertAdjacentElement);
  } else if (Native.Element_insertAdjacentElement) {
    patch_insertAdjacentElement(Element.prototype, Native.Element_insertAdjacentElement);
  } else {
    console.warn('Custom Elements: `Element#insertAdjacentElement` was not patched.');
  }
  function patch_insertAdjacentHTML(destination, baseMethod) {
    function upgradeNodesInRange(start, end) {
      const nodes = [];
      for (let node = start; node !== end; node = node.nextSibling) {
        nodes.push(node);
      }
      for (let i = 0; i < nodes.length; i++) {
        internals.patchAndUpgradeTree(nodes[i]);
      }
    }
    setPropertyUnchecked(destination, 'insertAdjacentHTML',
      function(position, text) {
        position = position.toLowerCase();
        if (position === "beforebegin") {
          const marker = this.previousSibling;
          baseMethod.call(this, position, text);
          upgradeNodesInRange(marker ||  (this.parentNode.firstChild), this);
        } else if (position === "afterbegin") {
          const marker = this.firstChild;
          baseMethod.call(this, position, text);
          upgradeNodesInRange( (this.firstChild), marker);
        } else if (position === "beforeend") {
          const marker = this.lastChild;
          baseMethod.call(this, position, text);
          upgradeNodesInRange(marker ||  (this.firstChild), null);
        } else if (position === "afterend") {
          const marker = this.nextSibling;
          baseMethod.call(this, position, text);
          upgradeNodesInRange( (this.nextSibling), marker);
        } else {
          throw new SyntaxError(`The value provided (${String(position)}) is ` +
            "not one of 'beforebegin', 'afterbegin', 'beforeend', or 'afterend'.");
        }
      });
  }
  if (Native.HTMLElement_insertAdjacentHTML) {
    patch_insertAdjacentHTML(HTMLElement.prototype, Native.HTMLElement_insertAdjacentHTML);
  } else if (Native.Element_insertAdjacentHTML) {
    patch_insertAdjacentHTML(Element.prototype, Native.Element_insertAdjacentHTML);
  } else {
    console.warn('Custom Elements: `Element#insertAdjacentHTML` was not patched.');
  }
  PatchParentNode(internals, Element.prototype, {
    prepend: Native.Element_prepend,
    append: Native.Element_append,
  });
  PatchChildNode(internals, Element.prototype, {
    before: Native.Element_before,
    after: Native.Element_after,
    replaceWith: Native.Element_replaceWith,
    remove: Native.Element_remove,
  });
}

const priorCustomElements = window['customElements'];
function installPolyfill() {
  const noDocumentConstructionObserver = priorCustomElements && priorCustomElements['noDocumentConstructionObserver'];
  const shadyDomFastWalk = priorCustomElements && priorCustomElements['shadyDomFastWalk'];
  const internals = new CustomElementInternals({
    noDocumentConstructionObserver,
    shadyDomFastWalk
  });
  PatchHTMLElement(internals);
  PatchDocument(internals);
  PatchDocumentFragment(internals);
  PatchNode(internals);
  PatchElement(internals);
  const customElements = new CustomElementRegistry(internals);
  document.__CE_registry = customElements;
  Object.defineProperty(window, 'customElements', {
    configurable: true,
    enumerable: true,
    value: customElements,
  });
}if (!priorCustomElements ||
     priorCustomElements['forcePolyfill'] ||
     (typeof priorCustomElements['define'] != 'function') ||
     (typeof priorCustomElements['get'] != 'function')) {
  installPolyfill();
}
window['__CE_installPolyfill'] = installPolyfill;

var customElements = /*#__PURE__*/Object.freeze({
  __proto__: null
});

class ShadyData {
  toJSON() {
    return {};
  }
}
function ensureShadyDataForNode(node) {
  if (!node.__shady) {
    node.__shady = new ShadyData();
  }
  return node.__shady;
}
function shadyDataForNode(node) {
  return node && node.__shady;
}

const settings = window['ShadyDOM'] || {};
settings.hasNativeShadowDOM = Boolean(Element.prototype.attachShadow && Node.prototype.getRootNode);
const desc = Object.getOwnPropertyDescriptor(Node.prototype, 'firstChild');
settings.hasDescriptors = Boolean(desc && desc.configurable && desc.get);
settings.inUse = settings['force'] || !settings.hasNativeShadowDOM;
settings.noPatch = settings['noPatch'] || false;
settings.preferPerformance = settings['preferPerformance'];
const IS_IE = navigator.userAgent.match('Trident');
settings.IS_IE = IS_IE;
const canUpgrade = () => !settings.IS_IE;
const isTrackingLogicalChildNodes = (node) => {
  const nodeData = shadyDataForNode(node);
  return (nodeData && nodeData.firstChild !== undefined);
};
const isShadyRoot = (obj) => {
  return Boolean(obj._localName === 'ShadyRoot');
};
const hasShadowRootWithSlot = (node) => {
  const nodeData = shadyDataForNode(node);
  let root = nodeData && nodeData.root;
  return (root && root._hasInsertionPoint());
};
let p = Element.prototype;
let matches = p.matches || p.matchesSelector ||
  p.mozMatchesSelector || p.msMatchesSelector ||
  p.oMatchesSelector || p.webkitMatchesSelector;
const matchesSelector = (element, selector) => {
  return matches.call(element, selector);
};
let twiddle = document.createTextNode('');
let content = 0;
let queue = [];
new MutationObserver(() => {
  while (queue.length) {
    try {
      queue.shift()();
    } catch(e) {
      twiddle.textContent = content++;
      throw(e);
    }
  }
}).observe(twiddle, {characterData: true});
const microtask = (callback) => {
  queue.push(callback);
  twiddle.textContent = content++;
};
const hasDocumentContains = Boolean(document.contains);
const contains = (container, node) => {
  while (node) {
    if (node == container) {
      return true;
    }
    node = node[SHADY_PREFIX + 'parentNode'];
  }
  return false;
};
const getNodeHTMLCollectionName = (node) =>
    node.getAttribute('id') || node.getAttribute('name');
const isValidHTMLCollectionName = (name) => name !== 'length' && isNaN(name);
const createPolyfilledHTMLCollection = (nodes) => {
  for (let l = nodes.length - 1; l >= 0; l--) {
    const node = nodes[l];
    const name = getNodeHTMLCollectionName(node);
    if (name && isValidHTMLCollectionName(name)) {
      nodes[name] = node;
    }
  }
  nodes.item = function(index) {
    return nodes[index];
  };
  nodes.namedItem = function(name) {
    if (isValidHTMLCollectionName(name) && nodes[name]) {
      return nodes[name];
    }
    for (const node of nodes) {
      const nodeName = getNodeHTMLCollectionName(node);
      if (nodeName == name) {
        return node;
      }
    }
    return null;
  };
  return nodes;
};
const NATIVE_PREFIX = '__shady_native_';
const SHADY_PREFIX = '__shady_';
const nativeChildNodesArray = (parent) => {
  const result = [];
  for (let n=parent[NATIVE_PREFIX + 'firstChild']; n; n = n[NATIVE_PREFIX + 'nextSibling']) {
    result.push(n);
  }
  return result;
};
const childNodesArray = (parent) => {
  const result = [];
  for (let n=parent[SHADY_PREFIX + 'firstChild']; n; n = n[SHADY_PREFIX + 'nextSibling']) {
    result.push(n);
  }
  return result;
};
const patchProperties = (proto, descriptors, prefix = '', disallowedPatches) => {
  for (let p in descriptors) {
    const newDescriptor = descriptors[p];
    if (disallowedPatches && disallowedPatches.indexOf(p) >= 0) {
      continue;
    }
    newDescriptor.configurable = true;
    const name = prefix + p;
    if (newDescriptor.value) {
      proto[name] = newDescriptor.value;
    } else {
      try {
        Object.defineProperty(proto, name, newDescriptor);
      } catch(e) {
      }
    }
  }
};
const getOwnPropertyDescriptors = (obj) => {
  const descriptors = {};
  Object.getOwnPropertyNames(obj).forEach((name) => {
    descriptors[name] = Object.getOwnPropertyDescriptor(obj, name);
  });
  return descriptors;
};

let flushList = [];
let scheduled;
function enqueue(callback) {
  if (!scheduled) {
    scheduled = true;
    microtask(flush);
  }
  flushList.push(callback);
}
function flush() {
  scheduled = false;
  let didFlush = Boolean(flushList.length);
  while (flushList.length) {
    flushList.shift()();
  }
  return didFlush;
}
flush['list'] = flushList;

class AsyncObserver {
  constructor() {
    this._scheduled = false;
    this.addedNodes = [];
    this.removedNodes = [];
    this.callbacks = new Set();
  }
  schedule() {
    if (!this._scheduled) {
      this._scheduled = true;
      microtask(() => {
        this.flush();
      });
    }
  }
  flush() {
    if (this._scheduled) {
      this._scheduled = false;
      let mutations = this.takeRecords();
      if (mutations.length) {
        this.callbacks.forEach(function(cb) {
          cb(mutations);
        });
      }
    }
  }
  takeRecords() {
    if (this.addedNodes.length || this.removedNodes.length) {
      let mutations = [{
        addedNodes: this.addedNodes,
        removedNodes: this.removedNodes
      }];
      this.addedNodes = [];
      this.removedNodes = [];
      return mutations;
    }
    return [];
  }
}
let observeChildren = function(node, callback) {
  const sd = ensureShadyDataForNode(node);
  if (!sd.observer) {
    sd.observer = new AsyncObserver();
  }
  sd.observer.callbacks.add(callback);
  let observer = sd.observer;
  return {
    _callback: callback,
    _observer: observer,
    _node: node,
    takeRecords() {
      return observer.takeRecords()
    }
  };
};
let unobserveChildren = function(handle) {
  let observer = handle && handle._observer;
  if (observer) {
    observer.callbacks.delete(handle._callback);
    if (!observer.callbacks.size) {
      ensureShadyDataForNode(handle._node).observer = null;
    }
  }
};
function filterMutations(mutations, target) {
  const targetRootNode = target.getRootNode();
  return mutations.map(function(mutation) {
    const mutationInScope = (targetRootNode === mutation.target.getRootNode());
    if (mutationInScope && mutation.addedNodes) {
      let nodes = Array.from(mutation.addedNodes).filter(function(n) {
        return (targetRootNode === n.getRootNode());
      });
      if (nodes.length) {
        mutation = Object.create(mutation);
        Object.defineProperty(mutation, 'addedNodes', {
          value: nodes,
          configurable: true
        });
        return mutation;
      }
    } else if (mutationInScope) {
      return mutation;
    }
  }).filter(function(m) { return m});
}

let escapeAttrRegExp = /[&\u00A0"]/g;
let escapeDataRegExp = /[&\u00A0<>]/g;
function escapeReplace(c) {
  switch (c) {
    case '&':
      return '&amp;';
    case '<':
      return '&lt;';
    case '>':
      return '&gt;';
    case '"':
      return '&quot;';
    case '\u00A0':
      return '&nbsp;';
  }
}
function escapeAttr(s) {
  return s.replace(escapeAttrRegExp, escapeReplace);
}
function escapeData(s) {
  return s.replace(escapeDataRegExp, escapeReplace);
}
function makeSet(arr) {
  let set = {};
  for (let i = 0; i < arr.length; i++) {
    set[arr[i]] = true;
  }
  return set;
}
let voidElements = makeSet([
  'area',
  'base',
  'br',
  'col',
  'command',
  'embed',
  'hr',
  'img',
  'input',
  'keygen',
  'link',
  'meta',
  'param',
  'source',
  'track',
  'wbr'
]);
let plaintextParents = makeSet([
  'style',
  'script',
  'xmp',
  'iframe',
  'noembed',
  'noframes',
  'plaintext',
  'noscript'
]);
function getOuterHTML(node, parentNode, callback) {
  switch (node.nodeType) {
    case Node.ELEMENT_NODE: {
      let tagName = node.localName;
      let s = '<' + tagName;
      let attrs = node.attributes;
      for (let i = 0, attr; (attr = attrs[i]); i++) {
        s += ' ' + attr.name + '="' + escapeAttr(attr.value) + '"';
      }
      s += '>';
      if (voidElements[tagName]) {
        return s;
      }
      return s + getInnerHTML(node, callback) + '</' + tagName + '>';
    }
    case Node.TEXT_NODE: {
      let data =  (node).data;
      if (parentNode && plaintextParents[parentNode.localName]) {
        return data;
      }
      return escapeData(data);
    }
    case Node.COMMENT_NODE: {
      return '<!--' +  (node).data + '-->';
    }
    default: {
      window.console.error(node);
      throw new Error('not implemented');
    }
  }
}
function getInnerHTML(node, callback) {
  if (node.localName === 'template') {
    node =   (node).content;
  }
  let s = '';
  let c$ = callback ? callback(node) : node.childNodes;
  for (let i=0, l=c$.length, child; (i<l) && (child=c$[i]); i++) {
    s += getOuterHTML(child, node, callback);
  }
  return s;
}

const hasDescriptors = settings.hasDescriptors;
const NATIVE_PREFIX$1 = NATIVE_PREFIX;
const nativeMethods = {
  querySelector(selector) {
    return this[NATIVE_PREFIX$1 + 'querySelector'](selector);
  },
  querySelectorAll(selector) {
    return this[NATIVE_PREFIX$1 + 'querySelectorAll'](selector);
  }
};
const nativeTree = {};
const installNativeAccessor = (name) => {
  nativeTree[name] = (node) => node[NATIVE_PREFIX$1 + name];
};
const installNativeMethod = (name, fn) => {
  if (!nativeMethods[name]) {
    nativeMethods[name] = fn;
  }
};
const defineNativeAccessors = (proto, descriptors) => {
  patchProperties(proto, descriptors, NATIVE_PREFIX$1);
  for (let prop in descriptors) {
    installNativeAccessor(prop);
  }
};
const copyProperties = (proto, list = []) => {
  for (let i = 0; i < list.length; i++) {
    const name = list[i];
    const descriptor = Object.getOwnPropertyDescriptor(proto, name);
    if (descriptor) {
      Object.defineProperty(proto, NATIVE_PREFIX$1 + name, descriptor);
      if (descriptor.value) {
        installNativeMethod(name, descriptor.value);
      } else {
        installNativeAccessor(name);
      }
    }
  }
};
const nodeWalker = document.createTreeWalker(document, NodeFilter.SHOW_ALL,
  null, false);
const elementWalker = document.createTreeWalker(document, NodeFilter.SHOW_ELEMENT,
  null, false);
const inertDoc = document.implementation.createHTMLDocument('inert');
const clearNode = node => {
  let firstChild;
  while ((firstChild = node[NATIVE_PREFIX$1 + 'firstChild'])) {
    node[NATIVE_PREFIX$1 + 'removeChild'](firstChild);
  }
};
const ParentNodeAccessors = [
  'firstElementChild',
  'lastElementChild',
  'children',
  'childElementCount',
];
const ParentNodeMethods = [
  'querySelector',
  'querySelectorAll'
];
const addNativePrefixedProperties = () => {
  const eventProps = [
    'dispatchEvent',
    'addEventListener',
    'removeEventListener'
  ];
  if (window.EventTarget) {
    copyProperties(window.EventTarget.prototype, eventProps);
  } else {
    copyProperties(Node.prototype, eventProps);
    copyProperties(Window.prototype, eventProps);
  }
  if (hasDescriptors) {
    copyProperties(Node.prototype, [
      'parentNode',
      'firstChild',
      'lastChild',
      'previousSibling',
      'nextSibling',
      'childNodes',
      'parentElement',
      'textContent',
    ]);
  } else {
    defineNativeAccessors(Node.prototype, {
      parentNode: {
        get() {
          nodeWalker.currentNode = this;
          return nodeWalker.parentNode();
        }
      },
      firstChild: {
        get() {
          nodeWalker.currentNode = this;
          return nodeWalker.firstChild();
        }
      },
      lastChild: {
        get() {
          nodeWalker.currentNode = this;
          return nodeWalker.lastChild();
        }
      },
      previousSibling: {
        get() {
          nodeWalker.currentNode = this;
          return nodeWalker.previousSibling();
        }
      },
      nextSibling: {
        get() {
          nodeWalker.currentNode = this;
          return nodeWalker.nextSibling();
        }
      },
      childNodes: {
        get() {
          const nodes = [];
          nodeWalker.currentNode = this;
          let n = nodeWalker.firstChild();
          while (n) {
            nodes.push(n);
            n = nodeWalker.nextSibling();
          }
          return nodes;
        }
      },
      parentElement: {
        get() {
          elementWalker.currentNode = this;
          return elementWalker.parentNode();
        }
      },
      textContent: {
        get() {
          switch (this.nodeType) {
            case Node.ELEMENT_NODE:
            case Node.DOCUMENT_FRAGMENT_NODE:
              const textWalker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT,
                null, false);
              let content = '', n;
              while ( (n = textWalker.nextNode()) ) {
                content += n.nodeValue;
              }
              return content;
            default:
              return this.nodeValue;
          }
        },
        set(value) {
          if (typeof value === 'undefined' || value === null) {
            value = '';
          }
          switch (this.nodeType) {
            case Node.ELEMENT_NODE:
            case Node.DOCUMENT_FRAGMENT_NODE:
              clearNode(this);
              if (value.length > 0 || this.nodeType === Node.ELEMENT_NODE) {
                this[NATIVE_PREFIX$1 + 'insertBefore'](document.createTextNode(value), undefined);
              }
              break;
            default:
              this.nodeValue = value;
              break;
          }
        }
      }
    });
  }
  copyProperties(Node.prototype, [
    'appendChild',
    'insertBefore',
    'removeChild',
    'replaceChild',
    'cloneNode',
    'contains'
  ]);
  copyProperties(HTMLElement.prototype, [
    'parentElement',
    'contains'
  ]);
  const ParentNodeWalkerDescriptors = {
    firstElementChild: {
      get() {
        elementWalker.currentNode = this;
        return elementWalker.firstChild();
      }
    },
    lastElementChild: {
      get() {
        elementWalker.currentNode = this;
        return elementWalker.lastChild();
      }
    },
    children: {
      get() {
        let nodes = [];
        elementWalker.currentNode = this;
        let n = elementWalker.firstChild();
        while (n) {
          nodes.push(n);
          n = elementWalker.nextSibling();
        }
        return createPolyfilledHTMLCollection(nodes);
      }
    },
    childElementCount: {
      get() {
        if (this.children) {
          return this.children.length;
        }
        return 0;
      }
    }
  };
  if (hasDescriptors) {
    copyProperties(Element.prototype, ParentNodeAccessors);
    copyProperties(Element.prototype, [
      'previousElementSibling',
      'nextElementSibling',
      'innerHTML',
      'className'
    ]);
    copyProperties(HTMLElement.prototype, [
      'children',
      'innerHTML',
      'className'
    ]);
  } else {
    defineNativeAccessors(Element.prototype, ParentNodeWalkerDescriptors);
    defineNativeAccessors(Element.prototype, {
      previousElementSibling: {
        get() {
          elementWalker.currentNode = this;
          return elementWalker.previousSibling();
        }
      },
      nextElementSibling: {
        get() {
          elementWalker.currentNode = this;
          return elementWalker.nextSibling();
        }
      },
      innerHTML: {
        get() {
          return getInnerHTML(this, nativeChildNodesArray);
        },
        set(value) {
          const content = this.localName === 'template' ?
          (this).content : this;
          clearNode(content);
          const containerName = this.localName || 'div';
          let htmlContainer;
          if (!this.namespaceURI || this.namespaceURI === inertDoc.namespaceURI) {
            htmlContainer = inertDoc.createElement(containerName);
          } else {
            htmlContainer = inertDoc.createElementNS(this.namespaceURI, containerName);
          }
          htmlContainer.innerHTML = value;
          const newContent = this.localName === 'template' ?
            (htmlContainer).content : htmlContainer;
          let firstChild;
          while ((firstChild = newContent[NATIVE_PREFIX$1 + 'firstChild'])) {
            content[NATIVE_PREFIX$1 + 'insertBefore'](firstChild, undefined);
          }
        }
      },
      className: {
        get() {
          return this.getAttribute('class') || '';
        },
        set(value) {
          this.setAttribute('class', value);
        }
      }
    });
  }
  copyProperties(Element.prototype, [
    'setAttribute',
    'getAttribute',
    'hasAttribute',
    'removeAttribute',
    'focus',
    'blur',
  ]);
  copyProperties(Element.prototype, ParentNodeMethods);
  copyProperties(HTMLElement.prototype, [
    'focus',
    'blur'
  ]);
  if (window.HTMLTemplateElement) {
    copyProperties(window.HTMLTemplateElement.prototype, ['innerHTML']);
  }
  if (hasDescriptors) {
    copyProperties(DocumentFragment.prototype, ParentNodeAccessors);
  } else {
    defineNativeAccessors(DocumentFragment.prototype, ParentNodeWalkerDescriptors);
  }
  copyProperties(DocumentFragment.prototype, ParentNodeMethods);
  if (hasDescriptors) {
    copyProperties(Document.prototype, ParentNodeAccessors);
    copyProperties(Document.prototype, [
      'activeElement'
    ]);
  } else {
    defineNativeAccessors(Document.prototype, ParentNodeWalkerDescriptors);
  }
  copyProperties(Document.prototype, [
    'importNode',
    'getElementById'
  ]);
  copyProperties(Document.prototype, ParentNodeMethods);
};

const InsideDescriptors = getOwnPropertyDescriptors({
  get childNodes() {
    return this[SHADY_PREFIX + 'childNodes'];
  },
  get firstChild() {
    return this[SHADY_PREFIX + 'firstChild'];
  },
  get lastChild() {
    return this[SHADY_PREFIX + 'lastChild'];
  },
  get childElementCount() {
    return this[SHADY_PREFIX + 'childElementCount'];
  },
  get children() {
    return this[SHADY_PREFIX + 'children'];
  },
  get firstElementChild() {
    return this[SHADY_PREFIX + 'firstElementChild'];
  },
  get lastElementChild() {
    return this[SHADY_PREFIX + 'lastElementChild'];
  },
  get shadowRoot() {
    return this[SHADY_PREFIX + 'shadowRoot'];
  },
});
const TextContentInnerHTMLDescriptors = getOwnPropertyDescriptors({
  get textContent() {
    return this[SHADY_PREFIX + 'textContent'];
  },
  set textContent(value) {
    this[SHADY_PREFIX + 'textContent'] = value;
  },
  get innerHTML() {
    return this[SHADY_PREFIX + 'innerHTML'];
  },
  set innerHTML(value) {
    return this[SHADY_PREFIX + 'innerHTML'] = value;
  },
});
const OutsideDescriptors = getOwnPropertyDescriptors({
  get parentElement() {
    return this[SHADY_PREFIX + 'parentElement'];
  },
  get parentNode() {
    return this[SHADY_PREFIX + 'parentNode'];
  },
  get nextSibling() {
    return this[SHADY_PREFIX + 'nextSibling'];
  },
  get previousSibling() {
    return this[SHADY_PREFIX + 'previousSibling'];
  },
  get nextElementSibling() {
    return this[SHADY_PREFIX + 'nextElementSibling'];
  },
  get previousElementSibling() {
    return this[SHADY_PREFIX + 'previousElementSibling'];
  },
  get className() {
    return this[SHADY_PREFIX + 'className'];
  },
  set className(value) {
    return this[SHADY_PREFIX + 'className'] = value;
  }
});
const makeNonEnumerable = (descriptors) => {
  for (let prop in descriptors) {
    const descriptor = descriptors[prop];
    if (descriptor) {
      descriptor.enumerable = false;
    }
  }
};
makeNonEnumerable(InsideDescriptors);
makeNonEnumerable(TextContentInnerHTMLDescriptors);
makeNonEnumerable(OutsideDescriptors);
const noInstancePatching = settings.hasDescriptors || settings.noPatch;
let patchOutsideElementAccessors = noInstancePatching ?
  function() {} : function(element) {
    const sd = ensureShadyDataForNode(element);
    if (!sd.__outsideAccessors) {
      sd.__outsideAccessors = true;
      patchProperties(element, OutsideDescriptors);
    }
  };
let patchInsideElementAccessors = noInstancePatching ?
  function() {} : function(element) {
    const sd = ensureShadyDataForNode(element);
    if (!sd.__insideAccessors) {
      sd.__insideAccessors = true;
      patchProperties(element, InsideDescriptors);
      if (!window['customElements'] || settings.noPatch) {
        patchProperties(element, TextContentInnerHTMLDescriptors);
      }
    }
  };

const  eventWrappersName = `__eventWrappers${Date.now()}`;
const composedGetter = (() => {
  const composedProp = Object.getOwnPropertyDescriptor(Event.prototype, 'composed');
  return composedProp ? (ev) => composedProp.get.call(ev) : null;
})();
const supportsEventOptions = (() => {
  let supported = false;
  let eventOptions = {
    get capture() {
      supported = true;
      return false;
    }
  };
  const listener = () => {};
  window.addEventListener('test', listener, eventOptions);
  window.removeEventListener('test', listener, eventOptions);
  return supported;
})();
const parseEventOptions = (optionsOrCapture) => {
  let capture, once, passive, shadyTarget;
  if (optionsOrCapture && typeof optionsOrCapture === 'object') {
    capture = Boolean(optionsOrCapture.capture);
    once = Boolean(optionsOrCapture.once);
    passive = Boolean(optionsOrCapture.passive);
    shadyTarget = optionsOrCapture.__shadyTarget;
  } else {
    capture = Boolean(optionsOrCapture);
    once = false;
    passive = false;
  }
  return {
    shadyTarget,
    capture,
    once,
    passive,
    nativeEventOptions: supportsEventOptions ? optionsOrCapture : capture
  }
};
const alwaysComposed = {
  'blur': true,
  'focus': true,
  'focusin': true,
  'focusout': true,
  'click': true,
  'dblclick': true,
  'mousedown': true,
  'mouseenter': true,
  'mouseleave': true,
  'mousemove': true,
  'mouseout': true,
  'mouseover': true,
  'mouseup': true,
  'wheel': true,
  'beforeinput': true,
  'input': true,
  'keydown': true,
  'keyup': true,
  'compositionstart': true,
  'compositionupdate': true,
  'compositionend': true,
  'touchstart': true,
  'touchend': true,
  'touchmove': true,
  'touchcancel': true,
  'pointerover': true,
  'pointerenter': true,
  'pointerdown': true,
  'pointermove': true,
  'pointerup': true,
  'pointercancel': true,
  'pointerout': true,
  'pointerleave': true,
  'gotpointercapture': true,
  'lostpointercapture': true,
  'dragstart': true,
  'drag': true,
  'dragenter': true,
  'dragleave': true,
  'dragover': true,
  'drop': true,
  'dragend': true,
  'DOMActivate': true,
  'DOMFocusIn': true,
  'DOMFocusOut': true,
  'keypress': true
};
const unpatchedEvents = {
  'DOMAttrModified': true,
  'DOMAttributeNameChanged': true,
  'DOMCharacterDataModified': true,
  'DOMElementNameChanged': true,
  'DOMNodeInserted': true,
  'DOMNodeInsertedIntoDocument': true,
  'DOMNodeRemoved': true,
  'DOMNodeRemovedFromDocument': true,
  'DOMSubtreeModified': true
};
function getRootNodeWithFallback(eventTarget) {
  if (eventTarget instanceof Node) {
    return eventTarget[SHADY_PREFIX + 'getRootNode']();
  } else {
    return eventTarget;
  }
}
function pathComposer(startNode, composed) {
  let composedPath = [];
  let current = startNode;
  let startRoot = getRootNodeWithFallback(startNode);
  while (current) {
    composedPath.push(current);
    if (current[SHADY_PREFIX + 'assignedSlot']) {
      current = current[SHADY_PREFIX + 'assignedSlot'];
    } else if (current.nodeType === Node.DOCUMENT_FRAGMENT_NODE && current.host && (composed || current !== startRoot)) {
      current = current.host;
    } else {
      current = current[SHADY_PREFIX + 'parentNode'];
    }
  }
  if (composedPath[composedPath.length - 1] === document) {
    composedPath.push(window);
  }
  return composedPath;
}
const composedPath = (event) => {
  if (!event.__composedPath) {
    event.__composedPath = pathComposer(event.target, true);
  }
  return event.__composedPath;
};
function retarget(refNode, path) {
  if (!isShadyRoot) {
    return refNode;
  }
  let refNodePath = pathComposer(refNode, true);
  let p$ = path;
  for (let i=0, ancestor, lastRoot, root, rootIdx; i < p$.length; i++) {
    ancestor = p$[i];
    root = getRootNodeWithFallback(ancestor);
    if (root !== lastRoot) {
      rootIdx = refNodePath.indexOf(root);
      lastRoot = root;
    }
    if (!isShadyRoot(root) || rootIdx > -1) {
      return ancestor;
    }
  }
}
let EventPatches = {
  get composed() {
    if (this.__composed === undefined) {
      if (composedGetter) {
        this.__composed = this.type === 'focusin' || this.type === 'focusout' || composedGetter(this);
      } else if (this.isTrusted !== false) {
        this.__composed = alwaysComposed[this.type];
      }
    }
    return (this).__composed || false;
  },
  composedPath() {
    if (!this.__composedPath) {
      this.__composedPath = pathComposer(this['__target'], this.composed);
    }
    return (this).__composedPath;
  },
  get target() {
    return retarget(this.currentTarget || this['__previousCurrentTarget'], this.composedPath());
  },
  get relatedTarget() {
    if (!this.__relatedTarget) {
      return null;
    }
    if (!this.__relatedTargetComposedPath) {
      this.__relatedTargetComposedPath = pathComposer(this.__relatedTarget, true);
    }
    return retarget(this.currentTarget || this['__previousCurrentTarget'], (this).__relatedTargetComposedPath);
  },
  stopPropagation() {
    Event.prototype.stopPropagation.call(this);
    this.__propagationStopped = true;
  },
  stopImmediatePropagation() {
    Event.prototype.stopImmediatePropagation.call(this);
    this.__immediatePropagationStopped = true;
    this.__propagationStopped = true;
  }
};
function mixinComposedFlag(Base) {
  let klazz = function(type, options) {
    let event = new Base(type, options);
    event.__composed = options && Boolean(options['composed']);
    return event;
  };
  klazz.__proto__ = Base;
  klazz.prototype = Base.prototype;
  return klazz;
}
let nonBubblingEventsToRetarget = {
  'focus': true,
  'blur': true
};
function hasRetargeted(event) {
  return event['__target'] !== event.target || event.__relatedTarget !== event.relatedTarget;
}
function fireHandlers(event, node, phase) {
  let hs = node.__handlers && node.__handlers[event.type] &&
    node.__handlers[event.type][phase];
  if (hs) {
    for (let i = 0, fn; (fn = hs[i]); i++) {
      if (hasRetargeted(event) && event.target === event.relatedTarget) {
        return;
      }
      fn.call(node, event);
      if (event.__immediatePropagationStopped) {
        return;
      }
    }
  }
}
function retargetNonBubblingEvent(e) {
  let path = e.composedPath();
  let node;
  Object.defineProperty(e, 'currentTarget', {
    get: function() {
      return node;
    },
    configurable: true
  });
  for (let i = path.length - 1; i >= 0; i--) {
    node = path[i];
    fireHandlers(e, node, 'capture');
    if (e.__propagationStopped) {
      return;
    }
  }
  Object.defineProperty(e, 'eventPhase', {get() { return Event.AT_TARGET }});
  let lastFiredRoot;
  for (let i = 0; i < path.length; i++) {
    node = path[i];
    const nodeData = shadyDataForNode(node);
    const root = nodeData && nodeData.root;
    if (i === 0 || (root && root === lastFiredRoot)) {
      fireHandlers(e, node, 'bubble');
      if (node !== window) {
        lastFiredRoot = node[SHADY_PREFIX + 'getRootNode']();
      }
      if (e.__propagationStopped) {
        return;
      }
    }
  }
}
function listenerSettingsEqual(savedListener, node, type, capture, once, passive) {
  let {
    node: savedNode,
    type: savedType,
    capture: savedCapture,
    once: savedOnce,
    passive: savedPassive
  } = savedListener;
  return node === savedNode &&
    type === savedType &&
    capture === savedCapture &&
    once === savedOnce &&
    passive === savedPassive;
}
function findListener(wrappers, node, type, capture, once, passive) {
  for (let i = 0; i < wrappers.length; i++) {
    if (listenerSettingsEqual(wrappers[i], node, type, capture, once, passive)) {
      return i;
    }
  }
  return -1;
}
function getEventWrappers(eventLike) {
  let wrappers = null;
  try {
    wrappers = eventLike[eventWrappersName];
  } catch (e) {}
  return wrappers;
}
function targetNeedsPathCheck(node) {
  return isShadyRoot(node) || node.localName === 'slot';
}
function dispatchEvent(event) {
  flush();
  return this[NATIVE_PREFIX + 'dispatchEvent'](event);
}
function addEventListener(type, fnOrObj, optionsOrCapture) {
  const {capture, once, passive, shadyTarget, nativeEventOptions} =
    parseEventOptions(optionsOrCapture);
  if (!fnOrObj) {
    return;
  }
  const handlerType = typeof fnOrObj;
  if (handlerType !== 'function' && handlerType !== 'object') {
    return;
  }
  if (handlerType === 'object' && (!fnOrObj.handleEvent || typeof fnOrObj.handleEvent !== 'function')) {
    return;
  }
  if (unpatchedEvents[type]) {
    return this[NATIVE_PREFIX + 'addEventListener'](type, fnOrObj, nativeEventOptions);
  }
  let target = shadyTarget || this;
  let wrappers = fnOrObj[eventWrappersName];
  if (wrappers) {
    if (findListener(wrappers, target, type, capture, once, passive) > -1) {
      return;
    }
  } else {
    fnOrObj[eventWrappersName] = [];
  }
  const wrapperFn = function(e) {
    if (once) {
      this[SHADY_PREFIX + 'removeEventListener'](type, fnOrObj, optionsOrCapture);
    }
    if (!e['__target']) {
      patchEvent(e);
    }
    let lastCurrentTargetDesc;
    if (target !== this) {
      lastCurrentTargetDesc = Object.getOwnPropertyDescriptor(e, 'currentTarget');
      Object.defineProperty(e, 'currentTarget', {get() { return target }, configurable: true});
    }
    e['__previousCurrentTarget'] = e['currentTarget'];
    if (targetNeedsPathCheck(target) && e.composedPath().indexOf(target) == -1) {
      return;
    }
    if (e.composed || e.composedPath().indexOf(target) > -1) {
      if (hasRetargeted(e) && e.target === e.relatedTarget) {
        if (e.eventPhase === Event.BUBBLING_PHASE) {
          e.stopImmediatePropagation();
        }
        return;
      }
      if (e.eventPhase !== Event.CAPTURING_PHASE && !e.bubbles && e.target !== target && !(target instanceof Window)) {
        return;
      }
      let ret = handlerType === 'function' ?
        fnOrObj.call(target, e) :
        (fnOrObj.handleEvent && fnOrObj.handleEvent(e));
      if (target !== this) {
        if (lastCurrentTargetDesc) {
          Object.defineProperty(e, 'currentTarget', lastCurrentTargetDesc);
          lastCurrentTargetDesc = null;
        } else {
          delete e['currentTarget'];
        }
      }
      return ret;
    }
  };
  fnOrObj[eventWrappersName].push({
    node: target,
    type: type,
    capture: capture,
    once: once,
    passive: passive,
    wrapperFn: wrapperFn
  });
  if (nonBubblingEventsToRetarget[type]) {
    this.__handlers = this.__handlers || {};
    this.__handlers[type] = this.__handlers[type] ||
      {'capture': [], 'bubble': []};
    this.__handlers[type][capture ? 'capture' : 'bubble'].push(wrapperFn);
  } else {
    this[NATIVE_PREFIX + 'addEventListener'](type, wrapperFn, nativeEventOptions);
  }
}
function removeEventListener(type, fnOrObj, optionsOrCapture) {
  if (!fnOrObj) {
    return;
  }
  const {capture, once, passive, shadyTarget, nativeEventOptions} =
    parseEventOptions(optionsOrCapture);
  if (unpatchedEvents[type]) {
    return this[NATIVE_PREFIX + 'removeEventListener'](type, fnOrObj, nativeEventOptions);
  }
  let target = shadyTarget || this;
  let wrapperFn = undefined;
  let wrappers = getEventWrappers(fnOrObj);
  if (wrappers) {
    let idx = findListener(wrappers, target, type, capture, once, passive);
    if (idx > -1) {
      wrapperFn = wrappers.splice(idx, 1)[0].wrapperFn;
      if (!wrappers.length) {
        fnOrObj[eventWrappersName] = undefined;
      }
    }
  }
  this[NATIVE_PREFIX + 'removeEventListener'](type, wrapperFn || fnOrObj,
    nativeEventOptions);
  if (wrapperFn && nonBubblingEventsToRetarget[type] &&
      this.__handlers && this.__handlers[type]) {
    const arr = this.__handlers[type][capture ? 'capture' : 'bubble'];
    const idx = arr.indexOf(wrapperFn);
    if (idx > -1) {
      arr.splice(idx, 1);
    }
  }
}
function activateFocusEventOverrides() {
  for (let ev in nonBubblingEventsToRetarget) {
    window[NATIVE_PREFIX + 'addEventListener'](ev, function(e) {
      if (!e['__target']) {
        patchEvent(e);
        retargetNonBubblingEvent(e);
      }
    }, true);
  }
}
const EventPatchesDescriptors = getOwnPropertyDescriptors(EventPatches);
const SHADY_PROTO = '__shady_patchedProto';
const SHADY_SOURCE_PROTO = '__shady_sourceProto';
function patchEvent(event) {
  event['__target'] = event.target;
  event.__relatedTarget = event.relatedTarget;
  if (settings.hasDescriptors) {
    const proto = Object.getPrototypeOf(event);
    if (!Object.hasOwnProperty(proto, SHADY_PROTO)) {
      const patchedProto = Object.create(proto);
      patchedProto[SHADY_SOURCE_PROTO] = proto;
      patchProperties(patchedProto, EventPatchesDescriptors);
      proto[SHADY_PROTO] = patchedProto;
    }
    event.__proto__ = proto[SHADY_PROTO];
  } else {
    patchProperties(event, EventPatchesDescriptors);
  }
}
let PatchedEvent = mixinComposedFlag(Event);
let PatchedCustomEvent = mixinComposedFlag(CustomEvent);
let PatchedMouseEvent = mixinComposedFlag(MouseEvent);
function patchEvents() {
  activateFocusEventOverrides();
  window.Event = PatchedEvent;
  window.CustomEvent = PatchedCustomEvent;
  window.MouseEvent = PatchedMouseEvent;
}
function patchClick() {
  if (!composedGetter && Object.getOwnPropertyDescriptor(Event.prototype, 'isTrusted')) {
    const composedClickFn = function() {
      const ev = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        composed: true
      });
      this[SHADY_PREFIX + 'dispatchEvent'](ev);
    };
    if (Element.prototype.click) {
      Element.prototype.click = composedClickFn;
    } else if (HTMLElement.prototype.click) {
      HTMLElement.prototype.click = composedClickFn;
    }
  }
}
const eventPropertyNames = Object.getOwnPropertyNames(Document.prototype)
    .filter(name => name.substring(0,2) === 'on');

function newSplice(index, removed, addedCount) {
  return {
    index: index,
    removed: removed,
    addedCount: addedCount
  };
}
const EDIT_LEAVE = 0;
const EDIT_UPDATE = 1;
const EDIT_ADD = 2;
const EDIT_DELETE = 3;
function calcEditDistances(current, currentStart, currentEnd,
                            old, oldStart, oldEnd) {
  let rowCount = oldEnd - oldStart + 1;
  let columnCount = currentEnd - currentStart + 1;
  let distances = new Array(rowCount);
  for (let i = 0; i < rowCount; i++) {
    distances[i] = new Array(columnCount);
    distances[i][0] = i;
  }
  for (let j = 0; j < columnCount; j++)
    distances[0][j] = j;
  for (let i = 1; i < rowCount; i++) {
    for (let j = 1; j < columnCount; j++) {
      if (equals(current[currentStart + j - 1], old[oldStart + i - 1]))
        distances[i][j] = distances[i - 1][j - 1];
      else {
        let north = distances[i - 1][j] + 1;
        let west = distances[i][j - 1] + 1;
        distances[i][j] = north < west ? north : west;
      }
    }
  }
  return distances;
}
function spliceOperationsFromEditDistances(distances) {
  let i = distances.length - 1;
  let j = distances[0].length - 1;
  let current = distances[i][j];
  let edits = [];
  while (i > 0 || j > 0) {
    if (i == 0) {
      edits.push(EDIT_ADD);
      j--;
      continue;
    }
    if (j == 0) {
      edits.push(EDIT_DELETE);
      i--;
      continue;
    }
    let northWest = distances[i - 1][j - 1];
    let west = distances[i - 1][j];
    let north = distances[i][j - 1];
    let min;
    if (west < north)
      min = west < northWest ? west : northWest;
    else
      min = north < northWest ? north : northWest;
    if (min == northWest) {
      if (northWest == current) {
        edits.push(EDIT_LEAVE);
      } else {
        edits.push(EDIT_UPDATE);
        current = northWest;
      }
      i--;
      j--;
    } else if (min == west) {
      edits.push(EDIT_DELETE);
      i--;
      current = west;
    } else {
      edits.push(EDIT_ADD);
      j--;
      current = north;
    }
  }
  edits.reverse();
  return edits;
}
function calcSplices(current, currentStart, currentEnd,
                      old, oldStart, oldEnd) {
  let prefixCount = 0;
  let suffixCount = 0;
  let splice;
  let minLength = Math.min(currentEnd - currentStart, oldEnd - oldStart);
  if (currentStart == 0 && oldStart == 0)
    prefixCount = sharedPrefix(current, old, minLength);
  if (currentEnd == current.length && oldEnd == old.length)
    suffixCount = sharedSuffix(current, old, minLength - prefixCount);
  currentStart += prefixCount;
  oldStart += prefixCount;
  currentEnd -= suffixCount;
  oldEnd -= suffixCount;
  if (currentEnd - currentStart == 0 && oldEnd - oldStart == 0)
    return [];
  if (currentStart == currentEnd) {
    splice = newSplice(currentStart, [], 0);
    while (oldStart < oldEnd)
      splice.removed.push(old[oldStart++]);
    return [ splice ];
  } else if (oldStart == oldEnd)
    return [ newSplice(currentStart, [], currentEnd - currentStart) ];
  let ops = spliceOperationsFromEditDistances(
      calcEditDistances(current, currentStart, currentEnd,
                             old, oldStart, oldEnd));
  splice = undefined;
  let splices = [];
  let index = currentStart;
  let oldIndex = oldStart;
  for (let i = 0; i < ops.length; i++) {
    switch(ops[i]) {
      case EDIT_LEAVE:
        if (splice) {
          splices.push(splice);
          splice = undefined;
        }
        index++;
        oldIndex++;
        break;
      case EDIT_UPDATE:
        if (!splice)
          splice = newSplice(index, [], 0);
        splice.addedCount++;
        index++;
        splice.removed.push(old[oldIndex]);
        oldIndex++;
        break;
      case EDIT_ADD:
        if (!splice)
          splice = newSplice(index, [], 0);
        splice.addedCount++;
        index++;
        break;
      case EDIT_DELETE:
        if (!splice)
          splice = newSplice(index, [], 0);
        splice.removed.push(old[oldIndex]);
        oldIndex++;
        break;
    }
  }
  if (splice) {
    splices.push(splice);
  }
  return splices;
}
function sharedPrefix(current, old, searchLength) {
  for (let i = 0; i < searchLength; i++)
    if (!equals(current[i], old[i]))
      return i;
  return searchLength;
}
function sharedSuffix(current, old, searchLength) {
  let index1 = current.length;
  let index2 = old.length;
  let count = 0;
  while (count < searchLength && equals(current[--index1], old[--index2]))
    count++;
  return count;
}
function equals(currentValue, previousValue) {
  return currentValue === previousValue;
}
function calculateSplices(current, previous) {
  return calcSplices(current, 0, current.length, previous, 0,
                          previous.length);
}

function linkNode(node, container, containerData, ref_node) {
  patchOutsideElementAccessors(node);
  ref_node = ref_node || null;
  const nodeData = ensureShadyDataForNode(node);
  const ref_nodeData = ref_node ? ensureShadyDataForNode(ref_node) : null;
  nodeData.previousSibling = ref_node ? ref_nodeData.previousSibling :
    container[SHADY_PREFIX + 'lastChild'];
  let psd = shadyDataForNode(nodeData.previousSibling);
  if (psd) {
    psd.nextSibling = node;
  }
  let nsd = shadyDataForNode(nodeData.nextSibling = ref_node);
  if (nsd) {
    nsd.previousSibling = node;
  }
  nodeData.parentNode = container;
  if (ref_node) {
    if (ref_node === containerData.firstChild) {
      containerData.firstChild = node;
    }
  } else {
    containerData.lastChild = node;
    if (!containerData.firstChild) {
      containerData.firstChild = node;
    }
  }
  containerData.childNodes = null;
}
const recordInsertBefore = (node, container, ref_node) => {
  patchInsideElementAccessors(container);
  const containerData = ensureShadyDataForNode(container);
  if (containerData.firstChild !== undefined) {
    containerData.childNodes = null;
  }
  if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
    const first = node[NATIVE_PREFIX + 'firstChild'];
    for (let n = first; n; (n = n[NATIVE_PREFIX + 'nextSibling'])) {
      linkNode(n, container, containerData, ref_node);
    }
  } else {
    linkNode(node, container, containerData, ref_node);
  }
};
const recordRemoveChild = (node, container) => {
  const nodeData = ensureShadyDataForNode(node);
  const containerData = ensureShadyDataForNode(container);
  if (node === containerData.firstChild) {
    containerData.firstChild = nodeData.nextSibling;
  }
  if (node === containerData.lastChild) {
    containerData.lastChild = nodeData.previousSibling;
  }
  let p = nodeData.previousSibling;
  let n = nodeData.nextSibling;
  if (p) {
    ensureShadyDataForNode(p).nextSibling = n;
  }
  if (n) {
    ensureShadyDataForNode(n).previousSibling = p;
  }
  nodeData.parentNode = nodeData.previousSibling =
  nodeData.nextSibling = undefined;
  if (containerData.childNodes !== undefined) {
    containerData.childNodes = null;
  }
};
const recordChildNodes = (node, adoptedParent) => {
  const nodeData = ensureShadyDataForNode(node);
  if (!adoptedParent && nodeData.firstChild !== undefined) {
    return;
  }
  nodeData.childNodes = null;
  const first = nodeData.firstChild = node[NATIVE_PREFIX + 'firstChild'];
  nodeData.lastChild = node[NATIVE_PREFIX + 'lastChild'];
  patchInsideElementAccessors(node);
  for (let n = first, previous; n; (n = n[NATIVE_PREFIX + 'nextSibling'])) {
    const sd = ensureShadyDataForNode(n);
    sd.parentNode = adoptedParent || node;
    sd.nextSibling = n[NATIVE_PREFIX + 'nextSibling'];
    sd.previousSibling = previous || null;
    previous = n;
    patchOutsideElementAccessors(n);
  }
};

let scopingShim = null;
function getScopingShim() {
  if (!scopingShim) {
    scopingShim = window['ShadyCSS'] && window['ShadyCSS']['ScopingShim'];
  }
  return scopingShim || null;
}
function scopeClassAttribute(node, attr, value) {
  const scopingShim = getScopingShim();
  if (scopingShim && attr === 'class') {
    scopingShim['setElementClass'](node, value);
    return true;
  }
  return false;
}
function addShadyScoping(node, newScopeName) {
  const scopingShim = getScopingShim();
  if (!scopingShim) {
    return;
  }
  scopingShim['scopeNode'](node, newScopeName);
}
function removeShadyScoping(node, currentScopeName) {
  const scopingShim = getScopingShim();
  if (!scopingShim) {
    return;
  }
  scopingShim['unscopeNode'](node, currentScopeName);
}
function replaceShadyScoping(node, newScopeName, oldScopeName) {
  const scopingShim = getScopingShim();
  if (!scopingShim) {
    return;
  }
  if (oldScopeName) {
    removeShadyScoping(node, oldScopeName);
  }
  addShadyScoping(node, newScopeName);
}
function currentScopeIsCorrect(node, newScopeName) {
  const scopingShim = getScopingShim();
  if (!scopingShim) {
    return true;
  }
  if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
    let correctScope = true;
    for (let n=node[SHADY_PREFIX + 'firstChild']; n; n = n[SHADY_PREFIX + 'nextSibling']) {
      correctScope = correctScope &&
        currentScopeIsCorrect(n, newScopeName);
    }
    return correctScope;
  }
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return true;
  }
  const currentScope = scopingShim['currentScopeForNode'](node);
  return currentScope === newScopeName;
}
function currentScopeForNode(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return '';
  }
  const scopingShim = getScopingShim();
  if (!scopingShim) {
    return '';
  }
  return scopingShim['currentScopeForNode'](node);
}
function treeVisitor(node, visitorFn) {
  if (!node) {
    return;
  }
  if (node.nodeType === Node.ELEMENT_NODE) {
    visitorFn(node);
  }
  for (let n = node[SHADY_PREFIX + 'firstChild']; n; (n = n[SHADY_PREFIX + 'nextSibling'])) {
    if (n.nodeType === Node.ELEMENT_NODE) {
      treeVisitor(n, visitorFn);
    }
  }
}

const doc = window.document;
const preferPerformance = settings.preferPerformance;
const nativeIsConnectedAccessors =
(
  Object.getOwnPropertyDescriptor(Node.prototype, 'isConnected')
);
const nativeIsConnected = nativeIsConnectedAccessors && nativeIsConnectedAccessors.get;
function clearNode$1(node) {
  let firstChild;
  while ((firstChild = node[SHADY_PREFIX + 'firstChild'])) {
    node[SHADY_PREFIX + 'removeChild'](firstChild);
  }
}
function removeOwnerShadyRoot(node) {
  if (hasCachedOwnerRoot(node)) {
    for (let n=node[SHADY_PREFIX + 'firstChild']; n; n = n[SHADY_PREFIX + 'nextSibling']) {
      removeOwnerShadyRoot(n);
    }
  }
  const nodeData = shadyDataForNode(node);
  if (nodeData) {
    nodeData.ownerShadyRoot = undefined;
  }
}
function hasCachedOwnerRoot(node) {
  const nodeData = shadyDataForNode(node);
  return Boolean(nodeData && nodeData.ownerShadyRoot !== undefined);
}
function firstComposedNode(node) {
  let composed = node;
  if (node && node.localName === 'slot') {
    const nodeData = shadyDataForNode(node);
    const flattened = nodeData && nodeData.flattenedNodes;
    composed = flattened && flattened.length ? flattened[0] :
      firstComposedNode(node[SHADY_PREFIX + 'nextSibling']);
  }
  return composed;
}
function scheduleObserver(node, addedNode, removedNode) {
  const nodeData = shadyDataForNode(node);
  const observer = nodeData && nodeData.observer;
  if (observer) {
    if (addedNode) {
      if (addedNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        observer.addedNodes.push(...addedNode.childNodes);
      } else {
        observer.addedNodes.push(addedNode);
      }
    }
    if (removedNode) {
      observer.removedNodes.push(removedNode);
    }
    observer.schedule();
  }
}
const NodePatches = getOwnPropertyDescriptors({
  get parentNode() {
    const nodeData = shadyDataForNode(this);
    const l = nodeData && nodeData.parentNode;
    return l !== undefined ? l : this[NATIVE_PREFIX + 'parentNode'];
  },
  get firstChild() {
    const nodeData = shadyDataForNode(this);
    const l = nodeData && nodeData.firstChild;
    return l !== undefined ? l : this[NATIVE_PREFIX + 'firstChild'];
  },
  get lastChild() {
    const nodeData = shadyDataForNode(this);
    const l = nodeData && nodeData.lastChild;
    return l !== undefined ? l : this[NATIVE_PREFIX + 'lastChild'];
  },
  get nextSibling() {
    const nodeData = shadyDataForNode(this);
    const l = nodeData && nodeData.nextSibling;
    return l !== undefined ? l : this[NATIVE_PREFIX + 'nextSibling'];
  },
  get previousSibling() {
    const nodeData = shadyDataForNode(this);
    const l = nodeData && nodeData.previousSibling;
    return l !== undefined ? l : this[NATIVE_PREFIX + 'previousSibling'];
  },
  get childNodes() {
    let childNodes;
    if (isTrackingLogicalChildNodes(this)) {
      const nodeData = shadyDataForNode(this);
      if (!nodeData.childNodes) {
        nodeData.childNodes = [];
        for (let n=this[SHADY_PREFIX + 'firstChild']; n; n=n[SHADY_PREFIX + 'nextSibling']) {
          nodeData.childNodes.push(n);
        }
      }
      childNodes = nodeData.childNodes;
    } else {
      childNodes = this[NATIVE_PREFIX + 'childNodes'];
    }
    childNodes.item = function(index) {
      return childNodes[index];
    };
    return childNodes;
  },
  get parentElement() {
    const nodeData = shadyDataForNode(this);
    let l = nodeData && nodeData.parentNode;
    if (l && l.nodeType !== Node.ELEMENT_NODE) {
      l = null;
    }
    return l !== undefined ? l : this[NATIVE_PREFIX + 'parentElement'];
  },
  get isConnected() {
    if (nativeIsConnected && nativeIsConnected.call(this)) {
      return true;
    }
    if (this.nodeType == Node.DOCUMENT_FRAGMENT_NODE) {
      return false;
    }
    const ownerDocument = this.ownerDocument;
    if (hasDocumentContains) {
      if (ownerDocument[NATIVE_PREFIX + 'contains'](this)) {
        return true;
      }
    } else if (ownerDocument.documentElement &&
      ownerDocument.documentElement[NATIVE_PREFIX + 'contains'](this)) {
      return true;
    }
    let node = this;
    while (node && !(node instanceof Document)) {
      node = node[SHADY_PREFIX + 'parentNode'] || (isShadyRoot(node) ? (node).host : undefined);
    }
    return !!(node && node instanceof Document);
  },
  get textContent() {
    if (isTrackingLogicalChildNodes(this)) {
      let tc = [];
      for (let n=this[SHADY_PREFIX + 'firstChild']; n; n = n[SHADY_PREFIX + 'nextSibling']) {
        if (n.nodeType !== Node.COMMENT_NODE) {
          tc.push(n[SHADY_PREFIX + 'textContent']);
        }
      }
      return tc.join('');
    } else {
      return this[NATIVE_PREFIX + 'textContent'];
    }
  },
  set textContent(value) {
    if (typeof value === 'undefined' || value === null) {
      value = '';
    }
    switch (this.nodeType) {
      case Node.ELEMENT_NODE:
      case Node.DOCUMENT_FRAGMENT_NODE:
        if (!isTrackingLogicalChildNodes(this) && settings.hasDescriptors) {
          const firstChild = this[SHADY_PREFIX + 'firstChild'];
          if (firstChild != this[SHADY_PREFIX + 'lastChild'] ||
            (firstChild && firstChild.nodeType != Node.TEXT_NODE)) {
            clearNode$1(this);
          }
          this[NATIVE_PREFIX + 'textContent'] = value;
        } else {
          clearNode$1(this);
          if (value.length > 0 || this.nodeType === Node.ELEMENT_NODE) {
            this[SHADY_PREFIX + 'insertBefore'](document.createTextNode(value));
          }
        }
        break;
      default:
        this.nodeValue = value;
        break;
    }
  },
  insertBefore(node, ref_node) {
    if (this.ownerDocument !== doc && node.ownerDocument !== doc) {
      this[NATIVE_PREFIX + 'insertBefore'](node, ref_node);
      return node;
    }
    if (node === this) {
      throw Error(`Failed to execute 'appendChild' on 'Node': The new child element contains the parent.`);
    }
    if (ref_node) {
      const refData = shadyDataForNode(ref_node);
      const p = refData && refData.parentNode;
      if ((p !== undefined && p !== this) ||
        (p === undefined && ref_node[NATIVE_PREFIX + 'parentNode'] !== this)) {
        throw Error(`Failed to execute 'insertBefore' on 'Node': The node ` +
        `before which the new node is to be inserted is not a child of this node.`);
      }
    }
    if (ref_node === node) {
      return node;
    }
    scheduleObserver(this, node);
    const slotsAdded = [];
    const ownerRoot = ownerShadyRootForNode(this);
    const newScopeName = ownerRoot ? ownerRoot.host.localName : currentScopeForNode(this);
    let oldScopeName;
    const parentNode = node[SHADY_PREFIX + 'parentNode'];
    if (parentNode) {
      oldScopeName = currentScopeForNode(node);
      const skipUnscoping =
        Boolean(ownerRoot) ||
        !ownerShadyRootForNode(node) ||
        (preferPerformance && this['__noInsertionPoint'] !== undefined);
      parentNode[SHADY_PREFIX + 'removeChild'](node, skipUnscoping);
    }
    let allowNativeInsert = true;
    const needsScoping = (!preferPerformance ||
        (node['__noInsertionPoint'] === undefined &&
         this['__noInsertionPoint'] === undefined)) &&
        !currentScopeIsCorrect(node, newScopeName);
    const needsSlotFinding = ownerRoot && !node['__noInsertionPoint'] &&
        (!preferPerformance || node.nodeType === Node.DOCUMENT_FRAGMENT_NODE);
    if (needsSlotFinding || needsScoping) {
      if (needsScoping) {
        oldScopeName = oldScopeName || currentScopeForNode(node);
      }
      treeVisitor(node, (node) => {
        if (needsSlotFinding && node.localName === 'slot') {
          slotsAdded.push((node));
        }
        if (needsScoping) {
          replaceShadyScoping(node, newScopeName, oldScopeName);
        }
      });
    }
    if (slotsAdded.length) {
      ownerRoot._addSlots(slotsAdded);
      ownerRoot._asyncRender();
    }
    if (isTrackingLogicalChildNodes(this)) {
      recordInsertBefore(node, this, ref_node);
      const parentData = shadyDataForNode(this);
      if (hasShadowRootWithSlot(this)) {
        parentData.root._asyncRender();
        allowNativeInsert = false;
      } else if (parentData.root) {
        allowNativeInsert = false;
      }
    }
    if (allowNativeInsert) {
      let container = isShadyRoot(this) ?
        (this).host : this;
      if (ref_node) {
        ref_node = firstComposedNode(ref_node);
        container[NATIVE_PREFIX + 'insertBefore'](node, ref_node);
      } else {
        container[NATIVE_PREFIX + 'appendChild'](node);
      }
    } else if (node.ownerDocument !== this.ownerDocument) {
      this.ownerDocument.adoptNode(node);
    }
    return node;
  },
  appendChild(node) {
    if (!(this == node && isShadyRoot(node))) {
      return this[SHADY_PREFIX + 'insertBefore'](node);
    }
  },
  removeChild(node, skipUnscoping = false) {
    if (this.ownerDocument !== doc) {
      return this[NATIVE_PREFIX + 'removeChild'](node);
    }
    if (node[SHADY_PREFIX + 'parentNode'] !== this) {
      throw Error('The node to be removed is not a child of this node: ' +
        node);
    }
    scheduleObserver(this, null, node);
    let preventNativeRemove;
    let ownerRoot = ownerShadyRootForNode(node);
    const removingInsertionPoint = ownerRoot && ownerRoot._removeContainedSlots(node);
    const parentData = shadyDataForNode(this);
    if (isTrackingLogicalChildNodes(this)) {
      recordRemoveChild(node, this);
      if (hasShadowRootWithSlot(this)) {
        parentData.root._asyncRender();
        preventNativeRemove = true;
      }
    }
    if (getScopingShim() && !skipUnscoping && ownerRoot
      && node.nodeType !== Node.TEXT_NODE) {
      const oldScopeName = currentScopeForNode(node);
      treeVisitor(node, (node) => {
        removeShadyScoping(node, oldScopeName);
      });
    }
    removeOwnerShadyRoot(node);
    if (ownerRoot) {
      let changeSlotContent = this && this.localName === 'slot';
      if (changeSlotContent) {
        preventNativeRemove = true;
      }
      if (removingInsertionPoint || changeSlotContent) {
        ownerRoot._asyncRender();
      }
    }
    if (!preventNativeRemove) {
      let container = isShadyRoot(this) ?
        (this).host :
        this;
      if (!(parentData.root || node.localName === 'slot') ||
        (container === node[NATIVE_PREFIX + 'parentNode'])) {
        container[NATIVE_PREFIX + 'removeChild'](node);
      }
    }
    return node;
  },
  replaceChild(node, ref_node) {
    this[SHADY_PREFIX + 'insertBefore'](node, ref_node);
    this[SHADY_PREFIX + 'removeChild'](ref_node);
    return node;
  },
  cloneNode(deep) {
    if (this.localName == 'template') {
      return this[NATIVE_PREFIX + 'cloneNode'](deep);
    } else {
      const n = this[NATIVE_PREFIX + 'cloneNode'](false);
      if (deep && n.nodeType !== Node.ATTRIBUTE_NODE) {
        for (let c=this[SHADY_PREFIX + 'firstChild'], nc; c; c = c[SHADY_PREFIX + 'nextSibling']) {
          nc = c[SHADY_PREFIX + 'cloneNode'](true);
          n[SHADY_PREFIX + 'appendChild'](nc);
        }
      }
      return n;
    }
  },
  getRootNode(options) {
    if (!this || !this.nodeType) {
      return;
    }
    const nodeData = ensureShadyDataForNode(this);
    let root = nodeData.ownerShadyRoot;
    if (root === undefined) {
      if (isShadyRoot(this)) {
        root = this;
        nodeData.ownerShadyRoot = root;
      } else {
        let parent = this[SHADY_PREFIX + 'parentNode'];
        root = parent ? parent[SHADY_PREFIX + 'getRootNode'](options) : this;
        if (document.documentElement[NATIVE_PREFIX + 'contains'](this)) {
          nodeData.ownerShadyRoot = root;
        }
      }
    }
    return root;
  },
  contains(node) {
    return contains(this, node);
  }
});

function query(node, matcher, halter) {
  let list = [];
  queryChildNodes(node, matcher,
    halter, list);
  return list;
}
function queryChildNodes(parent, matcher, halter, list) {
  for (let n = parent[SHADY_PREFIX + 'firstChild']; n; n = n[SHADY_PREFIX + 'nextSibling']) {
    if (n.nodeType === Node.ELEMENT_NODE &&
        queryElement(n, matcher, halter, list)) {
      return true;
    }
  }
}
function queryElement(node, matcher, halter, list) {
  let result = matcher(node);
  if (result) {
    list.push(node);
  }
  if (halter && halter(result)) {
    return result;
  }
  queryChildNodes(node, matcher,
    halter, list);
}
const ParentNodePatches = getOwnPropertyDescriptors({
  get firstElementChild() {
    const nodeData = shadyDataForNode(this);
    if (nodeData && nodeData.firstChild !== undefined) {
      let n = this[SHADY_PREFIX + 'firstChild'];
      while (n && n.nodeType !== Node.ELEMENT_NODE) {
        n = n[SHADY_PREFIX + 'nextSibling'];
      }
      return n;
    } else {
      return this[NATIVE_PREFIX + 'firstElementChild'];
    }
  },
  get lastElementChild() {
    const nodeData = shadyDataForNode(this);
    if (nodeData && nodeData.lastChild !== undefined) {
      let n = this[SHADY_PREFIX + 'lastChild'];
      while (n && n.nodeType !== Node.ELEMENT_NODE) {
        n = n[SHADY_PREFIX + 'previousSibling'];
      }
      return n;
    } else {
      return this[NATIVE_PREFIX + 'lastElementChild'];
    }
  },
  get children() {
    if (!isTrackingLogicalChildNodes(this)) {
      return this[NATIVE_PREFIX + 'children'];
    }
    return createPolyfilledHTMLCollection(Array.prototype.filter.call(
        childNodesArray(this), (n) => {
      return (n.nodeType === Node.ELEMENT_NODE);
    }));
  },
  get childElementCount() {
    let children = this[SHADY_PREFIX + 'children'];
    if(children) {
      return children.length;
    }
    return 0;
  }
});
const QueryPatches = getOwnPropertyDescriptors({
  querySelector(selector) {
    let result = query(this, function(n) {
      return matchesSelector(n, selector);
    }, function(n) {
      return Boolean(n);
    })[0];
    return result || null;
  },
  querySelectorAll(selector, useNative) {
    if (useNative) {
      const o = Array.prototype.slice.call(this[NATIVE_PREFIX + 'querySelectorAll'](selector));
      const root = this[SHADY_PREFIX + 'getRootNode']();
      return createPolyfilledHTMLCollection(o.filter(e => e[SHADY_PREFIX + 'getRootNode']() == root));
    }
    return createPolyfilledHTMLCollection(query(this, function(n) {
      return matchesSelector(n, selector);
    }));
  }
});
const ParentNodeDocumentOrFragmentPatches =
  (settings.preferPerformance && !settings.noPatch) ?
  Object.assign({}, ParentNodePatches) : ParentNodePatches;
Object.assign(ParentNodePatches, QueryPatches);

const DocumentOrFragmentPatches = getOwnPropertyDescriptors({
  getElementById(id) {
    if (id === '') {
      return null;
    }
    let result = query(this, function(n) {
      return n.id == id;
    }, function(n) {
      return Boolean(n);
    })[0];
    return result || null;
  }
});

function getDocumentActiveElement() {
  if (settings.hasDescriptors) {
    return document[NATIVE_PREFIX + 'activeElement'];
  } else {
    return document.activeElement;
  }
}
const DocumentOrShadowRootPatches = getOwnPropertyDescriptors({
  get activeElement() {
    let active = getDocumentActiveElement();
    if (!active || !active.nodeType) {
      return null;
    }
    let isShadyRoot$1 = !!(isShadyRoot(this));
    if (this !== document) {
      if (!isShadyRoot$1) {
        return null;
      }
      if (this.host === active ||
          !this.host[NATIVE_PREFIX + 'contains'](active)) {
        return null;
      }
    }
    let activeRoot = ownerShadyRootForNode(active);
    while (activeRoot && activeRoot !== this) {
      active = activeRoot.host;
      activeRoot = ownerShadyRootForNode(active);
    }
    if (this === document) {
      return activeRoot ? null : active;
    } else {
      return activeRoot === this ? active : null;
    }
  }
});

const inertDoc$1 = document.implementation.createHTMLDocument('inert');
const ElementOrShadowRootPatches = getOwnPropertyDescriptors({
  get innerHTML() {
    if (isTrackingLogicalChildNodes(this)) {
      const content = this.localName === 'template' ?
      (this).content : this;
      return getInnerHTML(content, childNodesArray);
    } else {
      return this[NATIVE_PREFIX + 'innerHTML'];
    }
  },
  set innerHTML(value) {
    if (this.localName === 'template') {
      this[NATIVE_PREFIX + 'innerHTML'] = value;
    } else {
      clearNode$1(this);
      const containerName = this.localName || 'div';
      let htmlContainer;
      if (!this.namespaceURI || this.namespaceURI === inertDoc$1.namespaceURI) {
        htmlContainer = inertDoc$1.createElement(containerName);
      } else {
        htmlContainer = inertDoc$1.createElementNS(this.namespaceURI, containerName);
      }
      if (settings.hasDescriptors) {
        htmlContainer[NATIVE_PREFIX + 'innerHTML'] = value;
      } else {
        htmlContainer.innerHTML = value;
      }
      let firstChild;
      while ((firstChild = htmlContainer[SHADY_PREFIX + 'firstChild'])) {
        this[SHADY_PREFIX + 'insertBefore'](firstChild);
      }
    }
  }
});

const ShadowRootPatches = getOwnPropertyDescriptors({
  addEventListener(type, fn, optionsOrCapture) {
    if (typeof optionsOrCapture !== 'object') {
      optionsOrCapture = {
        capture: Boolean(optionsOrCapture)
      };
    }
    optionsOrCapture.__shadyTarget = optionsOrCapture.__shadyTarget || this;
    this.host[SHADY_PREFIX + 'addEventListener'](type, fn, optionsOrCapture);
  },
  removeEventListener(type, fn, optionsOrCapture) {
    if (typeof optionsOrCapture !== 'object') {
      optionsOrCapture = {
        capture: Boolean(optionsOrCapture)
      };
    }
    optionsOrCapture.__shadyTarget = optionsOrCapture.__shadyTarget || this;
    this.host[SHADY_PREFIX + 'removeEventListener'](type, fn, optionsOrCapture);
  }
});

const patchShadyAccessors = (proto, prefix) => {
  patchProperties(proto, ShadowRootPatches, prefix);
  patchProperties(proto, DocumentOrShadowRootPatches, prefix);
  patchProperties(proto, ElementOrShadowRootPatches, prefix);
  patchProperties(proto, ParentNodePatches, prefix);
  if (settings.noPatch && !prefix) {
    patchProperties(proto, NodePatches, prefix);
    patchProperties(proto, DocumentOrFragmentPatches, prefix);
  } else if (!settings.hasDescriptors) {
    patchProperties(proto, OutsideDescriptors);
    patchProperties(proto, InsideDescriptors);
    patchProperties(proto, TextContentInnerHTMLDescriptors);
  }
};
const patchShadyRoot = (proto) => {
  proto.__proto__ = DocumentFragment.prototype;
  patchShadyAccessors(proto, SHADY_PREFIX);
  patchShadyAccessors(proto);
  Object.defineProperties(proto, {
    nodeType: {
      value: Node.DOCUMENT_FRAGMENT_NODE,
      configurable: true
    },
    nodeName: {
      value: '#document-fragment',
      configurable: true
    },
    nodeValue: {
      value: null,
      configurable: true
    }
  });
  [
    'localName',
    'namespaceURI',
    'prefix'
  ].forEach((prop) => {
    Object.defineProperty(proto, prop, {
      value: undefined,
      configurable: true
    });
  });
  [
    'ownerDocument',
    'baseURI',
    'isConnected'
  ].forEach((prop) => {
    Object.defineProperty(proto, prop, {
      get() {
        return this.host[prop];
      },
      configurable: true
    });
  });
};

const ShadyRootConstructionToken = {};
const CATCHALL_NAME = '__catchall';
const SHADYROOT_NAME = 'ShadyRoot';
const MODE_CLOSED = 'closed';
let isRendering = settings['deferConnectionCallbacks'] && document.readyState === 'loading';
let rootRendered;
function ancestorList(node) {
  let ancestors = [];
  do {
    ancestors.unshift(node);
  } while ((node = node[SHADY_PREFIX + 'parentNode']));
  return ancestors;
}
class ShadyRoot {
  constructor(token, host, options) {
    if (token !== ShadyRootConstructionToken) {
      throw new TypeError('Illegal constructor');
    }
    this._renderPending;
    this._hasRendered;
    this._slotList = null;
    this._slotMap;
    this._pendingSlots;
    this._init(host, options);
  }
  _init(host, options) {
    this._localName = SHADYROOT_NAME;
    this.host = host;
    this.mode = options && options.mode;
    recordChildNodes(this.host);
    const hostData = ensureShadyDataForNode(this.host);
    hostData.root = this;
    hostData.publicRoot = this.mode !== MODE_CLOSED ? this : null;
    const rootData = ensureShadyDataForNode(this);
    rootData.firstChild = rootData.lastChild =
        rootData.parentNode = rootData.nextSibling =
        rootData.previousSibling = null;
    if (settings['preferPerformance']) {
      let n;
      while ((n = this.host[NATIVE_PREFIX + 'firstChild'])) {
        this.host[NATIVE_PREFIX + 'removeChild'](n);
      }
    } else {
      this._asyncRender();
    }
  }
  _asyncRender() {
    if (!this._renderPending) {
      this._renderPending = true;
      enqueue(() => this._render());
    }
  }
  _getPendingDistributionRoot() {
    let renderRoot;
    let root = this;
    while (root) {
      if (root._renderPending) {
        renderRoot = root;
      }
      root = root._getDistributionParent();
    }
    return renderRoot;
  }
  _getDistributionParent() {
    let root = this.host[SHADY_PREFIX + 'getRootNode']();
    if (!isShadyRoot(root)) {
      return;
    }
    const nodeData = shadyDataForNode(this.host);
    if (nodeData && nodeData.__childSlotCount > 0) {
      return root;
    }
  }
  _render() {
    const root = this._renderPending && this._getPendingDistributionRoot();
    if (root) {
      root._renderSelf();
    }
  }
  _flushInitial() {
    if (!this._hasRendered && this._renderPending) {
      this._render();
    }
  }
  _renderSelf() {
    const wasRendering = isRendering;
    isRendering = true;
    this._renderPending = false;
    if (this._slotList) {
      this._distribute();
      this._compose();
    }
    if (!settings['preferPerformance'] && !this._hasRendered) {
      for (let n=this.host[SHADY_PREFIX + 'firstChild']; n; n = n[SHADY_PREFIX + 'nextSibling']) {
        const data = shadyDataForNode(n);
        if (n[NATIVE_PREFIX + 'parentNode'] === this.host &&
            (n.localName === 'slot' || !data.assignedSlot)) {
          this.host[NATIVE_PREFIX + 'removeChild'](n);
        }
      }
    }
    this._hasRendered = true;
    isRendering = wasRendering;
    if (rootRendered) {
      rootRendered();
    }
  }
  _distribute() {
    this._validateSlots();
    for (let i=0, slot; i < this._slotList.length; i++) {
      slot = this._slotList[i];
      this._clearSlotAssignedNodes(slot);
    }
    for (let n=this.host[SHADY_PREFIX + 'firstChild']; n; n=n[SHADY_PREFIX + 'nextSibling']) {
      this._distributeNodeToSlot(n);
    }
    for (let i=0; i < this._slotList.length; i++) {
      const slot = this._slotList[i];
      const slotData = shadyDataForNode(slot);
      if (!slotData.assignedNodes.length) {
        for (let n=slot[SHADY_PREFIX + 'firstChild']; n; n=n[SHADY_PREFIX + 'nextSibling']) {
          this._distributeNodeToSlot(n, slot);
        }
      }
      const slotParentData = shadyDataForNode(slot[SHADY_PREFIX + 'parentNode']);
      const slotParentRoot = slotParentData && slotParentData.root;
      if (slotParentRoot && (slotParentRoot._hasInsertionPoint() || slotParentRoot._renderPending)) {
        slotParentRoot._renderSelf();
      }
      this._addAssignedToFlattenedNodes(slotData.flattenedNodes,
        slotData.assignedNodes);
      let prevAssignedNodes = slotData._previouslyAssignedNodes;
      if (prevAssignedNodes) {
        for (let i=0; i < prevAssignedNodes.length; i++) {
          shadyDataForNode(prevAssignedNodes[i])._prevAssignedSlot = null;
        }
        slotData._previouslyAssignedNodes = null;
        if (prevAssignedNodes.length > slotData.assignedNodes.length) {
          slotData.dirty = true;
        }
      }
      if (slotData.dirty) {
        slotData.dirty = false;
        this._fireSlotChange(slot);
      }
    }
  }
  _distributeNodeToSlot(node, forcedSlot) {
    const nodeData = ensureShadyDataForNode(node);
    let oldSlot = nodeData._prevAssignedSlot;
    nodeData._prevAssignedSlot = null;
    let slot = forcedSlot;
    if (!slot) {
      let name = node[SHADY_PREFIX + 'slot'] || CATCHALL_NAME;
      const list = this._slotMap[name];
      slot = list && list[0];
    }
    if (slot) {
      const slotData = ensureShadyDataForNode(slot);
      slotData.assignedNodes.push(node);
      nodeData.assignedSlot = slot;
    } else {
      nodeData.assignedSlot = undefined;
    }
    if (oldSlot !== nodeData.assignedSlot) {
      if (nodeData.assignedSlot) {
        ensureShadyDataForNode(nodeData.assignedSlot).dirty = true;
      }
    }
  }
  _clearSlotAssignedNodes(slot) {
    const slotData = shadyDataForNode(slot);
    let n$ = slotData.assignedNodes;
    slotData.assignedNodes = [];
    slotData.flattenedNodes = [];
    slotData._previouslyAssignedNodes = n$;
    if (n$) {
      for (let i=0; i < n$.length; i++) {
        let n = shadyDataForNode(n$[i]);
        n._prevAssignedSlot = n.assignedSlot;
        if (n.assignedSlot === slot) {
          n.assignedSlot = null;
        }
      }
    }
  }
  _addAssignedToFlattenedNodes(flattened, assigned) {
    for (let i=0, n; (i<assigned.length) && (n=assigned[i]); i++) {
      if (n.localName == 'slot') {
        const nestedAssigned = shadyDataForNode(n).assignedNodes;
        if (nestedAssigned && nestedAssigned.length) {
          this._addAssignedToFlattenedNodes(flattened, nestedAssigned);
        }
      } else {
        flattened.push(assigned[i]);
      }
    }
  }
  _fireSlotChange(slot) {
    slot[NATIVE_PREFIX + 'dispatchEvent'](new Event('slotchange'));
    const slotData = shadyDataForNode(slot);
    if (slotData.assignedSlot) {
      this._fireSlotChange(slotData.assignedSlot);
    }
  }
  _compose() {
    const slots = this._slotList;
    let composeList = [];
    for (let i=0; i < slots.length; i++) {
      const parent = slots[i][SHADY_PREFIX + 'parentNode'];
      const parentData = shadyDataForNode(parent);
      if (!(parentData && parentData.root) &&
        composeList.indexOf(parent) < 0) {
        composeList.push(parent);
      }
    }
    for (let i=0; i < composeList.length; i++) {
      const node = composeList[i];
      const targetNode = node === this ? this.host : node;
      this._updateChildNodes(targetNode, this._composeNode(node));
    }
  }
  _composeNode(node) {
    let children = [];
    for (let n=node[SHADY_PREFIX + 'firstChild']; n; n = n[SHADY_PREFIX + 'nextSibling']) {
      if (this._isInsertionPoint(n)) {
        let flattenedNodes = shadyDataForNode(n).flattenedNodes;
        for (let j = 0; j < flattenedNodes.length; j++) {
          let distributedNode = flattenedNodes[j];
            children.push(distributedNode);
        }
      } else {
        children.push(n);
      }
    }
    return children;
  }
  _isInsertionPoint(node) {
      return node.localName == 'slot';
    }
  _updateChildNodes(container, children) {
    let composed = nativeChildNodesArray(container);
    let splices = calculateSplices(children, composed);
    for (let i=0, d=0, s; (i<splices.length) && (s=splices[i]); i++) {
      for (let j=0, n; (j < s.removed.length) && (n=s.removed[j]); j++) {
        if (n[NATIVE_PREFIX + 'parentNode'] === container) {
          container[NATIVE_PREFIX + 'removeChild'](n);
        }
        composed.splice(s.index + d, 1);
      }
      d -= s.addedCount;
    }
    for (let i=0, s, next; (i<splices.length) && (s=splices[i]); i++) {
      next = composed[s.index];
      for (let j=s.index, n; j < s.index + s.addedCount; j++) {
        n = children[j];
        container[NATIVE_PREFIX + 'insertBefore'](n, next);
        composed.splice(j, 0, n);
      }
    }
  }
  _ensureSlotData() {
    this._pendingSlots = this._pendingSlots || [];
    this._slotList = this._slotList || [];
    this._slotMap = this._slotMap || {};
  }
  _addSlots(slots) {
    this._ensureSlotData();
    this._pendingSlots.push(...slots);
  }
  _validateSlots() {
    if (this._pendingSlots && this._pendingSlots.length) {
      this._mapSlots(this._pendingSlots);
      this._pendingSlots = [];
    }
  }
  _mapSlots(slots) {
    let slotNamesToSort;
    for (let i=0; i < slots.length; i++) {
      const slot = slots[i];
      recordChildNodes(slot);
      const slotParent = slot[SHADY_PREFIX + 'parentNode'];
      recordChildNodes(slotParent);
      const slotParentData = shadyDataForNode(slotParent);
      slotParentData.__childSlotCount = (slotParentData.__childSlotCount || 0) + 1;
      let name = this._nameForSlot(slot);
      if (this._slotMap[name]) {
        slotNamesToSort = slotNamesToSort || {};
        slotNamesToSort[name] = true;
        this._slotMap[name].push(slot);
      } else {
        this._slotMap[name] = [slot];
      }
      this._slotList.push(slot);
    }
    if (slotNamesToSort) {
      for (let n in slotNamesToSort) {
        this._slotMap[n] = this._sortSlots(this._slotMap[n]);
      }
    }
  }
  _nameForSlot(slot) {
    const name = slot['name'] || slot.getAttribute('name') || CATCHALL_NAME;
    slot.__slotName = name;
    return name;
  }
  _sortSlots(slots) {
    return slots.sort((a, b) => {
      let listA = ancestorList(a);
      let listB = ancestorList(b);
      for (var i=0; i < listA.length; i++) {
        let nA = listA[i];
        let nB = listB[i];
        if (nA !== nB) {
          let c$ = childNodesArray(nA[SHADY_PREFIX + 'parentNode']);
          return c$.indexOf(nA) - c$.indexOf(nB);
        }
      }
    });
  }
  _removeContainedSlots(container) {
    if (!this._slotList) {
      return;
    }
    this._validateSlots();
    let didRemove;
    const map = this._slotMap;
    for (let n in map) {
      const slots = map[n];
      for (let i=0; i < slots.length; i++) {
        const slot = slots[i];
        if (contains(container, slot)) {
          slots.splice(i, 1);
          const x = this._slotList.indexOf(slot);
          if (x >= 0) {
            this._slotList.splice(x, 1);
            const slotParentData = shadyDataForNode(slot[SHADY_PREFIX + 'parentNode']);
            if (slotParentData && slotParentData.__childSlotCount) {
              slotParentData.__childSlotCount--;
            }
          }
          i--;
          this._removeFlattenedNodes(slot);
          didRemove = true;
        }
      }
    }
    return didRemove;
  }
  _updateSlotName(slot) {
    if (!this._slotList) {
      return;
    }
    this._validateSlots();
    const oldName = slot.__slotName;
    const name = this._nameForSlot(slot);
    if (name === oldName) {
      return;
    }
    let slots = this._slotMap[oldName];
    const i = slots.indexOf(slot);
    if (i >= 0) {
      slots.splice(i, 1);
    }
    let list = this._slotMap[name] || (this._slotMap[name] = []);
    list.push(slot);
    if (list.length > 1) {
      this._slotMap[name] = this._sortSlots(list);
    }
  }
  _removeFlattenedNodes(slot) {
    const data = shadyDataForNode(slot);
    let n$ = data.flattenedNodes;
    if (n$) {
      for (let i=0; i<n$.length; i++) {
        let node = n$[i];
        let parent = node[NATIVE_PREFIX + 'parentNode'];
        if (parent) {
          parent[NATIVE_PREFIX + 'removeChild'](node);
        }
      }
    }
    data.flattenedNodes = [];
    data.assignedNodes = [];
  }
  _hasInsertionPoint() {
    this._validateSlots();
    return Boolean(this._slotList && this._slotList.length);
  }
}
patchShadyRoot(ShadyRoot.prototype);
const attachShadow = (host, options) => {
  if (!host) {
    throw new Error('Must provide a host.');
  }
  if (!options) {
    throw new Error('Not enough arguments.');
  }
  let root;
  if (options['shadyUpgradeFragment'] && canUpgrade()) {
    root = options['shadyUpgradeFragment'];
    root.__proto__ = ShadowRoot.prototype;
    root._init(host, options);
    recordChildNodes(root, root);
    const slotsAdded = root['__noInsertionPoint'] ? null : root.querySelectorAll('slot');
    root['__noInsertionPoint'] = undefined;
    if (slotsAdded && slotsAdded.length) {
      root._addSlots(slotsAdded);
      root._asyncRender();
    }
    (root).host[NATIVE_PREFIX + 'appendChild'](root);
  } else {
    root = new ShadyRoot(ShadyRootConstructionToken, host, options);
  }
  return root;
};
if (window['customElements'] && settings.inUse && !settings['preferPerformance']) {
  let connectMap = new Map();
  rootRendered = function() {
    const r = [];
    connectMap.forEach((v, k) => {
      r.push([k, v]);
    });
    connectMap.clear();
    for (let i=0; i < r.length; i++) {
      const e = r[i][0], value = r[i][1];
      if (value) {
        e['__shadydom_connectedCallback']();
      } else {
        e['__shadydom_disconnectedCallback']();
      }
    }
  };
  if (isRendering) {
    document.addEventListener('readystatechange', () => {
      isRendering = false;
      rootRendered();
    }, {once: true});
  }
  const ManageConnect = (base, connected, disconnected) => {
    let counter = 0;
    const connectFlag = `__isConnected${counter++}`;
    if (connected || disconnected) {
      base.prototype.connectedCallback = base.prototype['__shadydom_connectedCallback'] = function() {
        if (isRendering) {
          connectMap.set(this, true);
        } else if (!this[connectFlag]) {
          this[connectFlag] = true;
          if (connected) {
            connected.call(this);
          }
        }
      };
      base.prototype.disconnectedCallback = base.prototype['__shadydom_disconnectedCallback'] = function() {
        if (isRendering) {
          if (!this.isConnected) {
            connectMap.set(this, false);
          }
        } else if (this[connectFlag]) {
          this[connectFlag] = false;
          if (disconnected) {
            disconnected.call(this);
          }
        }
      };
    }
    return base;
  };
  const originalDefine = window['customElements']['define'];
  const define = function(name, constructor) {
    const connected = constructor.prototype.connectedCallback;
    const disconnected = constructor.prototype.disconnectedCallback;
    originalDefine.call(window['customElements'], name,
        ManageConnect(constructor, connected, disconnected));
    constructor.prototype.connectedCallback = connected;
    constructor.prototype.disconnectedCallback = disconnected;
  };
  window.customElements.define = define;
  Object.defineProperty(window['CustomElementRegistry'].prototype, 'define', {
    value: define,
    configurable: true
  });
}
const ownerShadyRootForNode = (node) => {
  let root = node[SHADY_PREFIX + 'getRootNode']();
  if (isShadyRoot(root)) {
    return root;
  }
};

class Wrapper {
  constructor(node) {
    this.node = node;
  }
  addEventListener(name, fn, options) {
    return this.node[SHADY_PREFIX + 'addEventListener'](name, fn, options);
  }
  removeEventListener(name, fn, options) {
    return this.node[SHADY_PREFIX + 'removeEventListener'](name, fn, options);
  }
  appendChild(node) {
    return this.node[SHADY_PREFIX + 'appendChild'](node);
  }
  insertBefore(node, ref_node) {
    return this.node[SHADY_PREFIX + 'insertBefore'](node, ref_node);
  }
  removeChild(node) {
    return this.node[SHADY_PREFIX + 'removeChild'](node);
  }
  replaceChild(node, ref_node) {
    return this.node[SHADY_PREFIX + 'replaceChild'](node, ref_node);
  }
  cloneNode(deep) {
    return this.node[SHADY_PREFIX + 'cloneNode'](deep);
  }
  getRootNode(options) {
    return this.node[SHADY_PREFIX + 'getRootNode'](options);
  }
  contains(node) {
    return this.node[SHADY_PREFIX + 'contains'](node);
  }
  dispatchEvent(event) {
    return this.node[SHADY_PREFIX + 'dispatchEvent'](event);
  }
  setAttribute(name, value) {
    this.node[SHADY_PREFIX + 'setAttribute'](name, value);
  }
  getAttribute(name) {
    return this.node[NATIVE_PREFIX + 'getAttribute'](name);
  }
  hasAttribute(name) {
    return this.node[NATIVE_PREFIX + 'hasAttribute'](name);
  }
  removeAttribute(name) {
    this.node[SHADY_PREFIX + 'removeAttribute'](name);
  }
  attachShadow(options) {
    return this.node[SHADY_PREFIX + 'attachShadow'](options);
  }
  get activeElement() {
    if (isShadyRoot(this.node) || this.node.nodeType === Node.DOCUMENT_NODE) {
      const e = this.node[SHADY_PREFIX + 'activeElement'];
      return e;
    }
    return undefined;
  }
  get _activeElement() {
    return this.activeElement;
  }
  focus() {
    this.node[NATIVE_PREFIX + 'focus']();
  }
  blur() {
    this.node[SHADY_PREFIX + 'blur']();
  }
  importNode(node, deep) {
    if (this.node.nodeType === Node.DOCUMENT_NODE) {
      return this.node[SHADY_PREFIX + 'importNode'](node, deep);
    }
  }
  getElementById(id) {
    if (this.node.nodeType === Node.DOCUMENT_NODE) {
      return this.node[SHADY_PREFIX + 'getElementById'](id);
    }
  }
  querySelector(selector) {
    return this.node[SHADY_PREFIX + 'querySelector'](selector);
  }
  querySelectorAll(selector, useNative) {
    return this.node[SHADY_PREFIX + 'querySelectorAll'](selector, useNative);
  }
  assignedNodes(options) {
    if (this.node.localName === 'slot') {
      return this.node[SHADY_PREFIX + 'assignedNodes'](options);
    }
  }
  get host() {
    if (isShadyRoot(this.node)) {
      return (this.node).host;
    }
    return undefined;
  }
  get parentNode() {
    return this.node[SHADY_PREFIX + 'parentNode'];
  }
  get firstChild() {
    return this.node[SHADY_PREFIX + 'firstChild'];
  }
  get lastChild() {
    return this.node[SHADY_PREFIX + 'lastChild'];
  }
  get nextSibling() {
    return this.node[SHADY_PREFIX + 'nextSibling'];
  }
  get previousSibling() {
    return this.node[SHADY_PREFIX + 'previousSibling'];
  }
  get childNodes() {
    return this.node[SHADY_PREFIX + 'childNodes'];
  }
  get parentElement() {
    return this.node[SHADY_PREFIX + 'parentElement'];
  }
  get firstElementChild() {
    return this.node[SHADY_PREFIX + 'firstElementChild'];
  }
  get lastElementChild() {
    return this.node[SHADY_PREFIX + 'lastElementChild'];
  }
  get nextElementSibling() {
    return this.node[SHADY_PREFIX + 'nextElementSibling'];
  }
  get previousElementSibling() {
    return this.node[SHADY_PREFIX + 'previousElementSibling'];
  }
  get children() {
    return this.node[SHADY_PREFIX + 'children'];
  }
  get childElementCount() {
    return this.node[SHADY_PREFIX + 'childElementCount'];
  }
  get shadowRoot() {
    return this.node[SHADY_PREFIX + 'shadowRoot'];
  }
  get assignedSlot() {
    return this.node[SHADY_PREFIX + 'assignedSlot'];
  }
  get isConnected() {
    return this.node[SHADY_PREFIX + 'isConnected'];
  }
  get innerHTML() {
    return this.node[SHADY_PREFIX + 'innerHTML'];
  }
  set innerHTML(value) {
    this.node[SHADY_PREFIX + 'innerHTML'] = value;
  }
  get textContent() {
    return this.node[SHADY_PREFIX + 'textContent'];
  }
  set textContent(value) {
    this.node[SHADY_PREFIX + 'textContent'] = value;
  }
  get slot() {
    return this.node[SHADY_PREFIX + 'slot'];
  }
  set slot(value) {
    this.node[SHADY_PREFIX + 'slot'] = value;
  }
  get className() {
    return this.node[SHADY_PREFIX + 'className'];
  }
  set className(value) {
    return this.node[SHADY_PREFIX + 'className'] = value;
  }
}
eventPropertyNames.forEach(name => {
  Object.defineProperty(Wrapper.prototype, name, {
    get() {
      return this.node[SHADY_PREFIX + name];
    },
    set(value) {
      this.node[SHADY_PREFIX + name] = value;
    },
    configurable: true
  });
});
const wrapperMap = new WeakMap();
function wrap(obj) {
  if (isShadyRoot(obj) || obj instanceof Wrapper) {
    return obj;
  }
  let wrapper = wrapperMap.get(obj);
  if (!wrapper) {
    wrapper = new Wrapper(obj);
    wrapperMap.set(obj, wrapper);
  }
  return wrapper;
}

const EventTargetPatches = getOwnPropertyDescriptors({
  dispatchEvent,
  addEventListener,
  removeEventListener
});

const SlotablePatches = getOwnPropertyDescriptors({
  get assignedSlot() {
    const parent = this[SHADY_PREFIX + 'parentNode'];
    const ownerRoot = parent && parent[SHADY_PREFIX + 'shadowRoot'];
    if (ownerRoot) {
      ownerRoot._render();
    }
    const nodeData = shadyDataForNode(this);
    return nodeData && nodeData.assignedSlot || null;
  }
});

const doc$1 = window.document;
function distributeAttributeChange(node, name) {
  if (name === 'slot') {
    const parent = node[SHADY_PREFIX + 'parentNode'];
    if (hasShadowRootWithSlot(parent)) {
      shadyDataForNode(parent).root._asyncRender();
    }
  } else if (node.localName === 'slot' && name === 'name') {
    let root = ownerShadyRootForNode(node);
    if (root) {
      root._updateSlotName(node);
      root._asyncRender();
    }
  }
}
const ElementPatches = getOwnPropertyDescriptors({
  get previousElementSibling() {
    const nodeData = shadyDataForNode(this);
    if (nodeData && nodeData.previousSibling !== undefined) {
      let n = this[SHADY_PREFIX + 'previousSibling'];
      while (n && n.nodeType !== Node.ELEMENT_NODE) {
        n = n[SHADY_PREFIX + 'previousSibling'];
      }
      return n;
    } else {
      return this[NATIVE_PREFIX + 'previousElementSibling'];
    }
  },
  get nextElementSibling() {
    const nodeData = shadyDataForNode(this);
    if (nodeData && nodeData.nextSibling !== undefined) {
      let n = this[SHADY_PREFIX + 'nextSibling'];
      while (n && n.nodeType !== Node.ELEMENT_NODE) {
        n = n[SHADY_PREFIX + 'nextSibling'];
      }
      return n;
    } else {
      return this[NATIVE_PREFIX + 'nextElementSibling'];
    }
  },
  get slot() {
    return this.getAttribute('slot');
  },
  set slot(value) {
    this[SHADY_PREFIX + 'setAttribute']('slot', value);
  },
  get shadowRoot() {
    const nodeData = shadyDataForNode(this);
    return nodeData && nodeData.publicRoot || null;
  },
  get className() {
    return this.getAttribute('class') || '';
  },
  set className(value) {
    this[SHADY_PREFIX + 'setAttribute']('class', value);
  },
  setAttribute(attr, value) {
    if (this.ownerDocument !== doc$1) {
      this[NATIVE_PREFIX + 'setAttribute'](attr, value);
    } else if (!scopeClassAttribute(this, attr, value)) {
      this[NATIVE_PREFIX + 'setAttribute'](attr, value);
      distributeAttributeChange(this, attr);
    }
  },
  removeAttribute(attr) {
    if (this.ownerDocument !== doc$1) {
      this[NATIVE_PREFIX + 'removeAttribute'](attr);
    } else if (!scopeClassAttribute(this, attr, '')) {
      this[NATIVE_PREFIX + 'removeAttribute'](attr);
      distributeAttributeChange(this, attr);
    } else if (this.getAttribute(attr) === '') {
      this[NATIVE_PREFIX + 'removeAttribute'](attr);
    }
  },
  attachShadow(options) {
    return attachShadow(this, options);
  }
});

const HTMLElementPatches = getOwnPropertyDescriptors({
  blur() {
    const nodeData = shadyDataForNode(this);
    let root = nodeData && nodeData.root;
    let shadowActive = root && root.activeElement;
    if (shadowActive) {
      shadowActive[SHADY_PREFIX + 'blur']();
    } else {
      this[NATIVE_PREFIX + 'blur']();
    }
  }
});
eventPropertyNames.forEach(property => {
  HTMLElementPatches[property] = {
    set: function(fn) {
      const shadyData = ensureShadyDataForNode(this);
      const eventName = property.substring(2);
      if (!shadyData.__onCallbackListeners) {
        shadyData.__onCallbackListeners = {};
      }
      shadyData.__onCallbackListeners[property] && this.removeEventListener(eventName, shadyData.__onCallbackListeners[property]);
      this[SHADY_PREFIX + 'addEventListener'](eventName, fn);
      shadyData.__onCallbackListeners[property] = fn;
    },
    get() {
      const shadyData = shadyDataForNode(this);
      return shadyData && shadyData.__onCallbackListeners && shadyData.__onCallbackListeners[property];
    },
    configurable: true
  };
});

const SlotPatches = getOwnPropertyDescriptors({
  assignedNodes(options) {
    if (this.localName === 'slot') {
      const root = this[SHADY_PREFIX + 'getRootNode']();
      if (root && isShadyRoot(root)) {
        root._render();
      }
      const nodeData = shadyDataForNode(this);
      return nodeData ?
        ((options && options.flatten ? nodeData.flattenedNodes :
          nodeData.assignedNodes) || []) :
        [];
    }
  },
  addEventListener(type, fn, optionsOrCapture) {
    if (this.localName !== 'slot' || type === 'slotchange') {
      addEventListener.call(this, type, fn, optionsOrCapture);
    } else {
      if (typeof optionsOrCapture !== 'object') {
        optionsOrCapture = {
          capture: Boolean(optionsOrCapture)
        };
      }
      const parent = this[SHADY_PREFIX + 'parentNode'];
      if (!parent) {
        throw new Error('ShadyDOM cannot attach event to slot unless it has a `parentNode`');
      }
      optionsOrCapture.__shadyTarget = this;
      parent[SHADY_PREFIX + 'addEventListener'](type, fn, optionsOrCapture);
    }
  },
  removeEventListener(type, fn, optionsOrCapture) {
    if (this.localName !== 'slot' || type === 'slotchange') {
      removeEventListener.call(this, type, fn, optionsOrCapture);
    } else {
      if (typeof optionsOrCapture !== 'object') {
        optionsOrCapture = {
          capture: Boolean(optionsOrCapture)
        };
      }
      const parent = this[SHADY_PREFIX + 'parentNode'];
      if (!parent) {
        throw new Error('ShadyDOM cannot attach event to slot unless it has a `parentNode`');
      }
      optionsOrCapture.__shadyTarget = this;
      parent[SHADY_PREFIX + 'removeEventListener'](type, fn, optionsOrCapture);
    }
  }
});

const doc$2 = window.document;
const DocumentPatches = getOwnPropertyDescriptors({
  importNode(node, deep) {
    if (node.ownerDocument !== doc$2 || node.localName === 'template') {
      return this[NATIVE_PREFIX + 'importNode'](node, deep);
    }
    let n = this[NATIVE_PREFIX + 'importNode'](node, false);
    if (deep) {
      for (let c=node[SHADY_PREFIX + 'firstChild'], nc; c; c = c[SHADY_PREFIX + 'nextSibling']) {
        nc = this[SHADY_PREFIX + 'importNode'](c, true);
        n[SHADY_PREFIX + 'appendChild'](nc);
      }
    }
    return n;
  }
});

const WindowPatches = getOwnPropertyDescriptors({
  dispatchEvent,
  addEventListener: addEventListener.bind(window),
  removeEventListener: removeEventListener.bind(window)
});

const NonStandardHTMLElement = {};
if (Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'parentElement')) {
  NonStandardHTMLElement.parentElement = NodePatches.parentElement;
}
if (Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'contains')) {
  NonStandardHTMLElement.contains = NodePatches.contains;
}
if (Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'children')) {
  NonStandardHTMLElement.children = ParentNodePatches.children;
}
if (Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'innerHTML')) {
  NonStandardHTMLElement.innerHTML = ElementOrShadowRootPatches.innerHTML;
}
if (Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'className')) {
  NonStandardHTMLElement.className = ElementPatches.className;
}
const ElementShouldHaveInnerHTML = !settings.hasDescriptors || 'innerHTML' in Element.prototype;
const patchMap = {
  EventTarget: [EventTargetPatches],
  Node: [NodePatches, !window.EventTarget ? EventTargetPatches : null],
  Text: [SlotablePatches],
  Element: [ElementPatches, ParentNodePatches, SlotablePatches,
    ElementShouldHaveInnerHTML ? ElementOrShadowRootPatches : null,
    !window.HTMLSlotElement ? SlotPatches : null],
  HTMLElement: [HTMLElementPatches, NonStandardHTMLElement],
  HTMLSlotElement: [SlotPatches],
  DocumentFragment: [ParentNodeDocumentOrFragmentPatches, DocumentOrFragmentPatches],
  Document: [DocumentPatches, ParentNodeDocumentOrFragmentPatches, DocumentOrFragmentPatches, DocumentOrShadowRootPatches],
  Window: [WindowPatches]
};
const getPatchPrototype = (name) => window[name] && window[name].prototype;
const disallowedNativePatches = settings.hasDescriptors ? null : ['innerHTML', 'textContent'];
const applyPatches = (prefix) => {
  const disallowed = prefix ? null : disallowedNativePatches;
  for (let p in patchMap) {
    const proto = getPatchPrototype(p);
    patchMap[p].forEach(patch => proto && patch &&
        patchProperties(proto, patch, prefix, disallowed));
  }
};
const addShadyPrefixedProperties = () => {
  applyPatches(SHADY_PREFIX);
  const descriptor = DocumentOrShadowRootPatches.activeElement;
  Object.defineProperty(document, '_activeElement', descriptor);
  patchProperties(Window.prototype, WindowPatches, SHADY_PREFIX);
};

if (settings.inUse) {
  let ShadyDOM = {
    'inUse': settings.inUse,
    'patch': (node) => {
      patchInsideElementAccessors(node);
      patchOutsideElementAccessors(node);
      return node;
    },
    'isShadyRoot': isShadyRoot,
    'enqueue': enqueue,
    'flush': flush,
    'flushInitial': (root) => {
      root._flushInitial();
    },
    'settings': settings,
    'filterMutations': filterMutations,
    'observeChildren': observeChildren,
    'unobserveChildren': unobserveChildren,
    'deferConnectionCallbacks': settings['deferConnectionCallbacks'],
    'preferPerformance': settings['preferPerformance'],
    'handlesDynamicScoping': true,
    'wrap': settings.noPatch ? wrap : (n) => n,
    'Wrapper': Wrapper,
    'composedPath': composedPath,
    'noPatch': settings.noPatch,
    'nativeMethods': nativeMethods,
    'nativeTree': nativeTree
  };
  window['ShadyDOM'] = ShadyDOM;
  addNativePrefixedProperties();
  addShadyPrefixedProperties();
  if (!settings.noPatch) {
    applyPatches();
    patchClick();
  }
  patchEvents();
  window.ShadowRoot = (ShadyRoot);
}

var shadydom = /*#__PURE__*/Object.freeze({
  __proto__: null
});

export { customElements as customElementsPolyfill, shadydom as shadyDomPolyfill };
//# sourceMappingURL=web-components-polyfill.js.map
